import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
  import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
import FileSaver from 'file-saver'
import ReactHtmlParser from 'react-html-parser'
import CloseSVG from 'component/svgComponents/close'
import DownloadSVG from 'component/svgComponents/download'
import FilterSVG from 'component/svgComponents/filter'
import Form from 'component/commonReport/Form'
import Card from 'component/utils/Card'
import Modal from 'component/utils/Modal'
import CompactTable from 'component/utils/CompactTable'
import Accordion from 'component/utils/Accordion'
import { NavTab, Tab } from 'component/NavTab'
import * as reportActions from 'action/report'
import * as ruptureActions from 'action/rupture'
import Mask from 'vanilla-masker'
import { RUPTURE_TYPE } from 'constants/config'
import API_URL from 'constants/api'
import Api from 'utils/ApiRequest'

const AccordionTableTitleStores = ({
  branch,
  quantity,
  percentage,
}) => (
  <table className='table-compact text-uppercase'>
    <tbody>
      <tr />
      <tr>
        <td width='50%'>{branch}</td>
        <td width='25%' className='align-center'>
          {quantity}
        </td>
        <td width='25%' className='align-center'>
          {percentage}
        </td>
      </tr>
    </tbody>
  </table>
)

AccordionTableTitleStores.propTypes = {
  branch: PropTypes.string,
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  percentage: PropTypes.string,
}

const AccordionTableTitleLost = ({
  branch,
  value,
  percentage,
}) => (
  <table className='table-compact text-uppercase'>
    <tbody>
      <tr />
      <tr>
        <td width='50%'>{branch}</td>
        <td width='25%' className='align-center'>
          {value}
        </td>
        <td width='25%' className='align-center'>
          {percentage}
        </td>
      </tr>
    </tbody>
  </table>
)

AccordionTableTitleLost.propTypes = {
  branch: PropTypes.string,
  value: PropTypes.string,
  percentage: PropTypes.string,
}

const ReportDownloadBtn = ({ disabled, fullW, t, onReport }) => {
  let classNames = 'btn btn-download'
  if (fullW) classNames += ' full-w'

  const styles = {
    width: '18px',
    height: '18px',
    margin: '0px',
    marginRight: '16px',
    fill: '#fff',
  }
  return (
    <button disabled={disabled} onClick={onReport} className={classNames}>
      <DownloadSVG fill={styles.fill} style={styles} />
      <span>{t('commonReport.download')}</span>
    </button>
  )
}

ReportDownloadBtn.propTypes = {
  disabled: PropTypes.bool,
  fullW: PropTypes.bool,
  t: PropTypes.func,
  onReport: PropTypes.func,
}

class RuptureContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showReport: false,
      showFilters: false,
      formData: {},
      dateStartFiltered: null,
      dateEndFiltered: null,
      detailsMode: null,
      topStoreTab: false, 
      top2500StoreTab: false, 
      sectionsStoreTab: false, 
      salesStoreTab: false, 
      showDownloadLoader: false,
      downloadCancellable: false,
      showFilterLoader: false,
    }

    // Bind dos callbacks para evitar recriação a cada render
    this.handleBranchChange = this.handleBranchChange.bind(this)
    this.handleSectionChange = this.handleSectionChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)

    // refs para cancelar download quando possível
    this.downloadAbortController = null
    this.downloadTimeoutId = null
    this.downloadHideTimeoutId = null
    this.downloadLoaderStartedAt = 0
    this.downloadPromise = null
    this.isDownloadCancelled = false
    this.downloadCheckInterval = null

    // refs para cancelar requisição de filtro
    this.filterAbortController = null
    this.filterLoaderStartedAt = 0
    this.filterHideTimeoutId = null
    this.isFilterCancelled = false
  }

  startDownloadLoader = ({ cancellable = false, abortController = null, timeoutId = null } = {}) => {
    if (this.downloadHideTimeoutId) clearTimeout(this.downloadHideTimeoutId)
    this.downloadHideTimeoutId = null
    this.downloadLoaderStartedAt = Date.now()
    this.downloadAbortController = abortController
    this.downloadTimeoutId = timeoutId
    this.downloadPromise = null
    this.isDownloadCancelled = false
    this.setState({ showDownloadLoader: true, downloadCancellable: cancellable })
  }

  stopDownloadLoader = () => {
    this.downloadAbortController = null
    if (this.downloadTimeoutId) clearTimeout(this.downloadTimeoutId)
    this.downloadTimeoutId = null
    if (this.downloadCheckInterval) clearInterval(this.downloadCheckInterval)
    this.downloadCheckInterval = null
    this.downloadPromise = null

    // Garante um tempo mínimo de exibição do loader (evita "piscar" e às vezes nem renderizar)
    const MIN_VISIBLE_MS = 400
    const elapsed = Date.now() - (this.downloadLoaderStartedAt || 0)
    const remaining = MIN_VISIBLE_MS - elapsed

    if (remaining > 0) {
      if (this.downloadHideTimeoutId) clearTimeout(this.downloadHideTimeoutId)
      this.downloadHideTimeoutId = setTimeout(() => {
        this.downloadHideTimeoutId = null
        this.setState({ showDownloadLoader: false, downloadCancellable: false })
      }, remaining)
      return
    }

    this.setState({ showDownloadLoader: false, downloadCancellable: false })
  }

  onCancelDownload = () => {
    try {
      this.isDownloadCancelled = true
      // Limpa o timeout se existir
      if (this.downloadTimeoutId) {
        clearTimeout(this.downloadTimeoutId)
        this.downloadTimeoutId = null
      }
      // Aborta a requisição se houver um AbortController
      if (this.downloadAbortController) {
        this.downloadAbortController.abort()
      }
    } finally {
      this.stopDownloadLoader()
      // Preserva as datas do filtro e zera os outros dados
      const { formData } = this.state
      const preservedFormData = {
        dateStart: formData.dateStart || null,
        dateEnd: formData.dateEnd || null,
      }
      
      // Navega para a área dos cards com todas as informações zeradas, exceto as datas
      this.setState({
        showReport: true,
        showFilters: false,
        formData: preservedFormData,
        dateStartFiltered: formData.dateStart 
          ? moment(formData.dateStart).format('DD/MM/YYYY') 
          : null,
        dateEndFiltered: formData.dateEnd 
          ? moment(formData.dateEnd).format('DD/MM/YYYY') 
          : null,
      })
    }
  }

  startFilterLoader = () => {
    if (this.filterHideTimeoutId) clearTimeout(this.filterHideTimeoutId)
    this.filterHideTimeoutId = null
    this.filterLoaderStartedAt = Date.now()
    this.filterAbortController = new AbortController()
    this.isFilterCancelled = false
    this.setState({ showFilterLoader: true })
  }

  stopFilterLoader = () => {
    this.filterAbortController = null

    // Garante um tempo mínimo de exibição do loader (evita "piscar")
    const MIN_VISIBLE_MS = 400
    const elapsed = Date.now() - (this.filterLoaderStartedAt || 0)
    const remaining = MIN_VISIBLE_MS - elapsed

    if (remaining > 0) {
      if (this.filterHideTimeoutId) clearTimeout(this.filterHideTimeoutId)
      this.filterHideTimeoutId = setTimeout(() => {
        this.filterHideTimeoutId = null
        this.setState({ showFilterLoader: false })
      }, remaining)
      return
    }

    this.setState({ showFilterLoader: false })
  }

  onCancelFilter = () => {
    try {
      this.isFilterCancelled = true
      if (this.filterAbortController) {
        this.filterAbortController.abort()
      }
    } finally {
      this.stopFilterLoader()
      // Preserva as datas do filtro e zera os outros dados
      const { formData } = this.state
      const preservedFormData = {
        dateStart: formData.dateStart || null,
        dateEnd: formData.dateEnd || null,
      }
      
      // Navega para a área dos cards com todas as informações zeradas, exceto as datas
      this.setState({
        showReport: true,
        showFilters: false,
        formData: preservedFormData,
        dateStartFiltered: formData.dateStart 
          ? moment(formData.dateStart).format('DD/MM/YYYY') 
          : null,
        dateEndFiltered: formData.dateEnd 
          ? moment(formData.dateEnd).format('DD/MM/YYYY') 
          : null,
      })
    }
  }

  handleBranchChange(e) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        idBranches: e.target.value,
        locationId: e.target.value,
      },
    }))
  }

  handleSectionChange(e) {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        sections: this.formatSections(e),
      },
    }))
  }

  handleDateChange(e) {
    const formattedData = this.formatData(e)
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        ...formattedData,
      },
    }))
  }

  get filtersOverlayClassnames() {
    const { showFilters, showReport } = this.state

    let classNames = 'filters-overlay'
    if (showFilters && showReport) classNames += ' show'
    return classNames
  }

  get filtersClassnames() {
    const { showFilters, showReport } = this.state

    let classNames = 'filters'
    if (showReport) classNames += ' fixed'
    if (showFilters) classNames += ' open'
    return classNames
  }

  get formFields() {
    const { translate } = this.props

    return [
      {
        type: 'branchs',
        name: 'idBranches',
        label: translate('field.store'),
        help_text: translate('totalAccuracy.store'),
        required: true,
        onChangeValue: this.handleBranchChange,
      },
      {
        type: 'sections',
        name: 'section',
        help_text: translate('select.section'),
        label: translate('section'),
        required: true,
        onChangeValue: this.handleSectionChange,
      },
      {
        type: 'date_range',
        name: 'dtPeriod',
        label: translate('field.period.hint'),
        help_text: translate('totalAccuracy.dtYear.filter'),
        required: true,
        onChangeValue: this.handleDateChange,
      },
    ]
  }

  formatData(dtRange) {
    const dateStart = dtRange[0].format('YYYY-MM-DD')
    const dateEnd = dtRange[1].format('YYYY-MM-DD')
    return { dateStart, dateEnd }
  }

  formatSections(sections = {}) {
    const arraySections = Object.values(sections)
    return arraySections.map((s) => s.sectionId.toString())
  }

  formatBranchs(branchsObject = []) {
    const branchs = []
    for (const b of branchsObject) {
      if (b.idBranches) {
        branchs.push(...b.idBranches)
      } else {
        branchs.push(b.value)
      }
    }
    return branchs.filter((b, p) => branchs.indexOf(b) === p)
  }

  formatBranchsAndRegions(branchsObject = []) {
    const idBranches = []
    const idRegions = []

    for (const b of branchsObject) {
      const isPrimitive = b === null || typeof b !== 'object'
      if (isPrimitive) {
        idBranches.push(String(b))
        continue
      }
      if (b.isBranch !== undefined) {
        idBranches.push(b.value)
      } else {
        idRegions.push(b.value)
      }
    }

    return {
      idBranches: idBranches.filter((x, p) => idBranches.indexOf(x) === p),
      idRegions: idRegions.filter((r, p) => idRegions.indexOf(r) === p),
    }
  }

  /**
   * Normaliza o formData enviado pelo Form (dtPeriod, section, idBranches)
   * para o formato usado no estado e nos filtros (dateStart, dateEnd, sections, etc.).
   */
  normalizeFormDataFromForm(formDataFromForm = {}) {
    const dtPeriod = formDataFromForm.dtPeriod || []
    const dateStart = (dtPeriod[0] && String(dtPeriod[0]).substring(0, 10)) || null
    const dateEnd = (dtPeriod[1] && String(dtPeriod[1]).substring(0, 10)) || null
    const section = formDataFromForm.section
    const sections = Array.isArray(section)
      ? section.map((s) => (typeof s === 'object' && s != null && s.sectionId != null ? String(s.sectionId) : String(s)))
      : []
    const idBranches = formDataFromForm.idBranches || formDataFromForm.locationId || []

    const out = {
      ...formDataFromForm,
      dateStart: dateStart || formDataFromForm.dateStart,
      dateEnd: dateEnd || formDataFromForm.dateEnd,
      sections: sections.length ? sections : (formDataFromForm.sections || []),
      idBranches: idBranches.length ? idBranches : (formDataFromForm.idBranches || []),
      locationId: idBranches.length ? idBranches : (formDataFromForm.locationId || []),
    }
    return out
  }

  handleFilterSubmit = (formDataFromForm) => {
    const { fetchRuptures, auth } = this.props
    const formData = formDataFromForm
      ? this.normalizeFormDataFromForm(formDataFromForm)
      : this.state.formData

    if (!formData.dateStart || !formData.dateEnd) {
      return
    }

    const dateStartFiltered = moment(formData.dateStart).format('DD/MM/YYYY')
    const dateEndFiltered = moment(formData.dateEnd).format('DD/MM/YYYY')

    const branchData = this.formatBranchsAndRegions(formData.idBranches || formData.locationId || [])
    const filters = {
      dtEnd: moment(formData.dateEnd).format('DD/MM/YYYY'),
      dtStart: moment(formData.dateStart).format('DD/MM/YYYY'),
      idBranches: branchData.idBranches,
      idRegions: branchData.idRegions,
      idSections: (formData.sections || []).map((s) => parseInt(s, 10)),
      allBranches: false,
    }

    // Inicia o loader customizado com botão cancelar
    this.startFilterLoader()

    this.setState({
      dateEndFiltered,
      dateStartFiltered,
      showFilters: false,
      formData,
    })

    if (fetchRuptures && auth) {
      // Passa o signal do AbortController para permitir cancelamento
      fetchRuptures(auth, filters, this.filterAbortController?.signal)
        .then(() => {
          // Só mostra o relatório se não foi cancelado
          if (!this.isFilterCancelled) {
            this.setState({ showReport: true })
          }
          this.stopFilterLoader()
        })
        .catch((error) => {
          // Não exibe erro se foi cancelado pelo usuário
          this.stopFilterLoader()
        })
    }
  }

  getCsv = () => {
    const { formData } = this.state
    const { auth, translate, fetchReports } = this.props

    const user = auth?.user
    if (!user || !user.dsToken) {
      return
    }

    if (!formData.dateStart || !formData.dateEnd) {
      return
    }

    // Formata filiais e regiões
    const branchData = this.formatBranchsAndRegions(formData.idBranches || formData.locationId || [])

    const filters = {
      dtStart: moment(formData.dateStart).format('DD/MM/YYYY'),
      dtEnd: moment(formData.dateEnd).format('DD/MM/YYYY'),
      idBranches: branchData.idBranches || [],
      idRegions: branchData.idRegions || [],
      // backend espera lista de inteiros em idSections (ReportParam)
      idSections: (formData.sections || []).map((s) => parseInt(s, 10)),
      allBranches: false,
    }

    if ((!filters.idBranches || filters.idBranches.length === 0) && !filters.allBranches) {
      filters.idBranch = auth?.user?.locationCode
    }

    // Monta o body para o POST - endpoint original reportAsCsv
    // Não usa fetchReports para evitar o spinner global que aparece
    const requestBody = {
      dtStart: moment(formData.dateStart).format('DD/MM/YYYY'),
      dtEnd: moment(formData.dateEnd).format('DD/MM/YYYY'),
      idBranches: branchData.idBranches || [],
      idRegions: branchData.idRegions || [],
      // backend espera lista de inteiros em idSections (ReportParam)
      idSections: (formData.sections || []).map((s) => parseInt(s, 10)),
      allBranches: false,
    }

    const url = API_URL.RUPTURE_REPORT_CSV

    // Cria AbortController ANTES de iniciar o loader para permitir cancelamento
    const controller = new AbortController()
    const timeoutId = setTimeout(() => controller.abort(), 300000) // 5 minutos

    // Abre modal de carregamento durante a geração/baixar do relatório
    // Passa o controller e timeoutId para permitir cancelamento
    this.startDownloadLoader({ cancellable: true, abortController: controller, timeoutId })

    // Usa a mesma estrutura dos cards: setTimeout com fetch
    setTimeout(() => {
      try {
        // Usa fetch com POST para o endpoint reportAsCsv
        fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': user.dsToken,
            'lm-application': '1',
          },
          body: JSON.stringify(requestBody),
          signal: controller.signal,
        })
        .then(response => {
          // Verifica se foi cancelado antes de processar
          if (this.isDownloadCancelled || controller.signal.aborted) {
            return
          }
          return response.json()
        })
        .then(responseData => {
          // Verifica se foi cancelado antes de processar
          if (this.isDownloadCancelled || controller.signal.aborted) {
            return
          }

          // Se erro do backend
          if (responseData?.cdStatus !== 200 || !responseData?.data) {
            this.stopDownloadLoader()
            return
          }
          
          // O endpoint reportAsCsv retorna o CSV como string diretamente
          const csvContent = responseData.data
          
          if (typeof csvContent !== 'string' || csvContent.length === 0) {
            this.stopDownloadLoader()
            return
          }
          
          // Salva o arquivo CSV - mesma estrutura dos cards
          clearTimeout(timeoutId)
          const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' })
          FileSaver.saveAs(blob, `ruptura_${moment().format('YYYY-MM-DD_HH-mm')}.csv`)
          this.stopDownloadLoader()
        })
        .catch(error => {
          // Não exibe erro se foi cancelado pelo usuário
          if (error.name === 'AbortError' || this.isDownloadCancelled) {
            // Download foi cancelado, apenas limpa o loader
            clearTimeout(timeoutId)
            return
          }
          clearTimeout(timeoutId)
          this.stopDownloadLoader()
        })
      } catch (error) {
        // Não exibe erro se foi cancelado pelo usuário
        if (error.name === 'AbortError' || this.isDownloadCancelled) {
          return
        }
        this.stopDownloadLoader()
      }
    }, 0)
  }

  /**
   * Gera um relatório CSV completo com todas as informações visuais da ruptura
   * Inclui os 4 cards: Ruptura Total, Coração do Sortimento, Por Seção e Perda de Receita
   */
  generateFullRuptureReport = () => {
    this.startDownloadLoader({ cancellable: false })
    setTimeout(() => {
      try {
        const { rupture = {}, translate } = this.props
        const { dateStartFiltered, dateEndFiltered } = this.state

        const currency = translate('option.currency')
        const sizeCurrency = parseInt(translate('size.currency'), 10) || 2
        const formatCurrency = {
          separator: translate('separator.currency'),
          delimiter: translate('delimiter.currency'),
        }

        let csvContent = ''

    // ========== CABEÇALHO DO RELATÓRIO ==========
    const periodInfo = `${translate('field.period.hint')}: ${dateStartFiltered || moment().format('DD/MM/YYYY')} - ${dateEndFiltered || moment().format('DD/MM/YYYY')}\n\n`
    csvContent += periodInfo

    // ========== RESUMO GERAL ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.ruptureTitle').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n\n`

    // Totais dos 4 cards
    const totalLossValue = this.totalLossOfSalesByStore || 0
    const formattedTotalLoss = `${currency} ${Mask.toMoney(totalLossValue.toFixed(sizeCurrency), formatCurrency)}`

    csvContent += `${translate('ruptures.ruptureTitle')}: ${rupture?.total || 0} LMs\n`
    csvContent += `${translate('ruptures.heartTitle')}: ${rupture?.topThousand || 0} LMs\n`
    csvContent += `${translate('ruptures.sectionTitle')}: ${this.totalLMsBySection || 0} LMs\n`
    csvContent += `${translate('ruptures.lossSaleTitle')}: ${formattedTotalLoss}\n\n`

    // ========== CARD 1: RUPTURA TOTAL - POR TOP ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.ruptureTitle').toUpperCase()} - ${translate('ruptures.top').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.top')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

    const listLMPerTop = rupture?.listLMPerTop || []
    listLMPerTop.forEach(item => {
      const ds = item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || ''
      csvContent += `${ds};${item.quantity || 0};${item.percent || 0}%\n`
    })
    csvContent += '\n'

    // ========== CARD 1: RUPTURA TOTAL - POR LOJA ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.ruptureTitle').toUpperCase()} - ${translate('scheduleBlock.branchs').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('scheduleBlock.branchs')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

    let listLMPerStore = rupture?.listLMPerStore || []
    if (listLMPerStore.length > 0 && listLMPerStore[0]?.listLMPerTop !== undefined) {
      listLMPerStore = listLMPerStore
        .filter(store => (store.total || store.quantity || 0) > 0)
        .map(store => ({
          ds: store.dsBranch
            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
            : store.ds || store.name || store.idBranch || '',
          quantity: store.total || store.quantity || 0,
          percent: store.percent || 0,
        }))
    } else {
      listLMPerStore = listLMPerStore
        .filter(store => (store.quantity || 0) > 0)
        .map(store => ({
          ds: store.ds || store.name || '',
          quantity: store.quantity || 0,
          percent: store.percent || 0,
        }))
    }
    listLMPerStore.forEach(item => {
      csvContent += `${item.ds};${item.quantity};${item.percent}%\n`
    })
    csvContent += '\n'

    // ========== CARD 2: CORAÇÃO DO SORTIMENTO - POR SEÇÃO ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.heartTitle').toUpperCase()} - ${translate('ruptures.section').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.section')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

    const rawListTop2500 = rupture?.listLMPerSectionTopThousand || []
    const sectionMapTop2500 = new Map()
    rawListTop2500.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMapTop2500.has(key)) {
        sectionMapTop2500.set(key, { ...section })
      }
    })
    const listTop2500 = Array.from(sectionMapTop2500.values())
    // Ordenar por código numérico da seção
    const sortedListTop2500 = [...listTop2500].sort((a, b) => {
      const codeA = parseInt(a.cd) || 0
      const codeB = parseInt(b.cd) || 0
      return codeA - codeB
    })
    sortedListTop2500.forEach(item => {
      const ds = item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || ''
      csvContent += `${ds};${item.quantity || 0};${item.percent || 0}%\n`
    })
    csvContent += '\n'

    // ========== CARD 2: CORAÇÃO DO SORTIMENTO - POR LOJA ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.heartTitle').toUpperCase()} - ${translate('scheduleBlock.branchs').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('scheduleBlock.branchs')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

    let listTop2500PerStore = rupture?.listLMPerStoreTopThousand || rupture?.listLMPerSectionTopThousandByStore || []
    if (listTop2500PerStore.length > 0 && listTop2500PerStore[0]?.listLMPerTop !== undefined) {
      listTop2500PerStore = listTop2500PerStore
        .filter(store => (store.total || store.quantity || 0) > 0)
        .map(store => ({
          ds: store.dsBranch
            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
            : store.ds || store.name || store.idBranch || '',
          quantity: store.total || store.quantity || 0,
          percent: store.percent || 0,
        }))
    } else {
      listTop2500PerStore = listTop2500PerStore
        .filter(store => (store.total || store.quantity || 0) > 0)
        .map(store => ({
          ds: store.ds || store.name || '',
          quantity: store.total || store.quantity || 0,
          percent: store.percent || 0,
        }))
    }
    listTop2500PerStore.forEach(item => {
      csvContent += `${item.ds};${item.quantity};${item.percent}%\n`
    })
    csvContent += '\n'

    // ========== CARD 3: POR SEÇÃO - SEÇÕES ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.sectionTitle').toUpperCase()} - ${translate('ruptures.section').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.section')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

    const rawListSection = rupture?.listLMPerSection || []
    const sectionMapSection = new Map()
    rawListSection.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMapSection.has(key)) {
        sectionMapSection.set(key, { ...section })
      }
    })
    const listSection = Array.from(sectionMapSection.values())
    // Ordenar por código numérico da seção
    const sortedListSection = [...listSection].sort((a, b) => {
      const codeA = parseInt(a.cd) || 0
      const codeB = parseInt(b.cd) || 0
      return codeA - codeB
    })
    sortedListSection.forEach(item => {
      const ds = item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || ''
      csvContent += `${ds};${item.quantity || 0};${item.percent || 0}%\n`
    })
    csvContent += '\n'

    // ========== CARD 3: POR SEÇÃO - POR LOJA ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.sectionTitle').toUpperCase()} - ${translate('scheduleBlock.branchs').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('scheduleBlock.branchs')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

    let listSectionPerStore = rupture?.listLMPerStoreSections || rupture?.listLMPerSectionByStore || []
    if (listSectionPerStore.length > 0 && listSectionPerStore[0]?.listLMPerTop !== undefined) {
      listSectionPerStore = listSectionPerStore
        .filter(store => (store.total || store.quantity || 0) > 0)
        .map(store => ({
          ds: store.dsBranch
            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
            : store.ds || store.name || store.idBranch || '',
          quantity: store.total || store.quantity || 0,
          percent: store.percent || 0,
        }))
    } else {
      listSectionPerStore = listSectionPerStore
        .filter(store => (store.quantity || 0) > 0)
        .map(store => ({
          ds: store.ds || store.name || '',
          quantity: store.quantity || 0,
          percent: store.percent || 0,
        }))
    }
    listSectionPerStore.forEach(item => {
      csvContent += `${item.ds};${item.quantity};${item.percent}%\n`
    })
    csvContent += '\n'

    // ========== CARD 4: PERDA DE RECEITA - POR SEÇÃO ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.lossSaleTitle').toUpperCase()} - ${translate('ruptures.section').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.section')};${translate('ruptures.estimatedLoss').replace('{0}', currency)};${translate('percentage')}\n`

    const rawListLoss = rupture?.listRupturePerSection || []
    const sectionMapLoss = new Map()
    rawListLoss.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMapLoss.has(key)) {
        sectionMapLoss.set(key, { ...section })
      }
    })
    const listLoss = Array.from(sectionMapLoss.values())
    // Ordenar por código numérico da seção
    const sortedListLoss = [...listLoss].sort((a, b) => {
      const codeA = parseInt(a.cd) || 0
      const codeB = parseInt(b.cd) || 0
      return codeA - codeB
    })
    sortedListLoss.forEach(item => {
      const ds = item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || ''
      const value = item.quantity || item.value || 0
      const formattedValue = `${currency} ${Mask.toMoney(value.toFixed(sizeCurrency), formatCurrency)}`
      csvContent += `${ds};${formattedValue};${item.percent || 0}%\n`
    })
    csvContent += '\n'

    // ========== CARD 4: PERDA DE RECEITA - POR LOJA ==========
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('ruptures.lossSaleTitle').toUpperCase()} - ${translate('scheduleBlock.branchs').toUpperCase()}\n`
    csvContent += `${'='.repeat(50)}\n`
    csvContent += `${translate('scheduleBlock.branchs')};${translate('order_status.value')};${translate('percentage')}\n`

    let listLossPerStore = rupture?.listRupturePerStore || rupture?.listRupturePerSectionByStore || []
    if (listLossPerStore.length > 0 && listLossPerStore[0]?.listLMPerTop !== undefined) {
      listLossPerStore = listLossPerStore
        .filter(store => (store.total || store.quantity || 0) > 0)
        .map(store => ({
          ds: store.dsBranch
            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
            : store.ds || store.name || store.idBranch || '',
          value: store.total || store.quantity || 0,
          percent: store.percent || 0,
        }))
    } else {
      listLossPerStore = listLossPerStore
        .filter(store => (store.value || store.quantity || 0) > 0)
        .map(store => ({
          ds: store.ds || store.name || store.branch || '',
          value: store.value || store.quantity || 0,
          percent: store.percent || 0,
        }))
    }
    listLossPerStore.forEach(item => {
      const formattedValue = `${currency} ${Mask.toMoney((item.value || 0).toFixed(sizeCurrency), formatCurrency)}`
      csvContent += `${item.ds};${formattedValue};${item.percent}%\n`
    })

    // ========== SALVAR ARQUIVO ==========
        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' })
        FileSaver.saveAs(blob, `relatorio_ruptura_completo_${moment().format('YYYY-MM-DD_HH-mm')}.csv`)
      } finally {
        this.stopDownloadLoader()
      }
    }, 0)
  }

  /**
   * Gera CSV com os dados exibidos na tela (TOP, Quantidade de LMs, Porcentagem)
   * para o primeiro card (Ruptura Total)
   */
  generateCsvFromScreenData = () => {
    this.startDownloadLoader({ cancellable: false })
    setTimeout(() => {
      try {
        const { rupture = {}, translate } = this.props
        const { dateStartFiltered, dateEndFiltered, topStoreTab } = this.state

        // Define o cabeçalho baseado na aba selecionada
        let csvContent = ''
        let fileName = 'ruptura_total'

    if (topStoreTab) {
      // Aba "Por Loja" - dados expandidos por loja e TOP
      const storesList = rupture?.listLMPerStore || []

      // Cabeçalho do CSV: Loja, TOP, Quantidade de LMs, Porcentagem
      csvContent = `${translate('scheduleBlock.branchs')};${translate('ruptures.top')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

      // Se houver dados da API com a nova estrutura (listLMPerTop dentro de cada loja)
      if (storesList.length > 0 && storesList[0]?.listLMPerTop !== undefined) {
        storesList.forEach(store => {
          const storeName = store.dsBranch
            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
            : store.ds || store.name || store.idBranch || ''

          const topList = store.listLMPerTop || []
          topList.forEach(top => {
            const topName = top.cd ? `${top.cd} - ${top.ds || ''}` : top.ds || ''
            csvContent += `${storeName};${topName};${top.quantity || 0};${top.percent || 0}%\n`
          })
        })
      } else {
        // Fallback para estrutura antiga (sem listLMPerTop)
        storesList
          .filter(store => (store.quantity || 0) > 0)
          .forEach(store => {
            const storeName = store.ds || store.name || ''
            csvContent += `${storeName};;${store.quantity || 0};${store.percent || 0}%\n`
          })
      }

      fileName = 'ruptura_total_por_loja'
    } else {
      // Aba "Por TOP" - dados agrupados por TOP
      const list = rupture?.listLMPerTop || []

      // Cabeçalho do CSV
      csvContent = `${translate('ruptures.top')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

      // Dados
      list.forEach(item => {
        const ds = item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || ''
        csvContent += `${ds};${item.quantity || 0};${item.percent || 0}%\n`
      })

      fileName = 'ruptura_total_por_top'
    }

    // Cria o blob e faz o download
        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' })
        FileSaver.saveAs(blob, `${fileName}_${moment().format('YYYY-MM-DD_HH-mm')}.csv`)
      } finally {
        this.stopDownloadLoader()
      }
    }, 0)
  }

  /**
   * Gera CSV com os dados exibidos na tela para o segundo card (TOP 2500 / Coração do Sortimento)
   */
  generateCsvTop2500 = () => {
    this.startDownloadLoader({ cancellable: false })
    setTimeout(() => {
      try {
        const { rupture = {}, translate } = this.props
        const { dateStartFiltered, dateEndFiltered, top2500StoreTab } = this.state

        let csvContent = ''
        let fileName = 'top_2500'

    if (top2500StoreTab) {
      // Aba "Por Loja" - dados expandidos por loja e seção
      const storesList = rupture?.listLMPerStoreTopThousand || rupture?.listLMPerSectionTopThousandByStore || []

      // Cabeçalho do CSV: Loja, Seção, Quantidade de LMs, Porcentagem
      csvContent = `${translate('scheduleBlock.branchs')};${translate('ruptures.section')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

      // Se houver dados da API com a nova estrutura (listLMPerTop dentro de cada loja)
      if (storesList.length > 0 && storesList[0]?.listLMPerTop !== undefined) {
        storesList.forEach(store => {
          const storeName = store.dsBranch
            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
            : store.ds || store.name || store.idBranch || ''

          const sectionList = store.listLMPerTop || []
          sectionList.forEach(section => {
            const sectionName = section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || ''
            csvContent += `${storeName};${sectionName};${section.quantity || 0};${section.percent || 0}%\n`
          })
        })
      } else {
        // Fallback para estrutura antiga (sem listLMPerTop)
        storesList
          .filter(store => (store.total || store.quantity || 0) > 0)
          .forEach(store => {
            const storeName = store.ds || store.name || ''
            csvContent += `${storeName};;${store.total || store.quantity || 0};${store.percent || 0}%\n`
          })
      }

      fileName = 'top_2500_por_loja'
    } else {
      // Aba "Por Seção"
      const rawList = rupture?.listLMPerSectionTopThousand || []

      // Remover duplicatas
      const sectionMap = new Map()
      rawList.forEach(section => {
        const key = section.cd || section.ds || ''
        if (!sectionMap.has(key)) {
          sectionMap.set(key, { ...section })
        }
      })
      const list = Array.from(sectionMap.values())

      // Ordenar por código numérico da seção (mesma ordem da tela)
      const sortedList = [...list].sort((a, b) => {
        const codeA = parseInt(a.cd) || 0
        const codeB = parseInt(b.cd) || 0
        return codeA - codeB
      })

      csvContent = `${translate('ruptures.section')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

      sortedList.forEach(item => {
        const ds = item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || ''
        csvContent += `${ds};${item.quantity || 0};${item.percent || 0}%\n`
      })

      fileName = 'top_2500_por_secao'
    }

        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' })
        FileSaver.saveAs(blob, `${fileName}_${moment().format('YYYY-MM-DD_HH-mm')}.csv`)
      } finally {
        this.stopDownloadLoader()
      }
    }, 0)
  }

  /**
   * Gera CSV com os dados exibidos na tela para o terceiro card (Por Seção)
   */
  generateCsvSections = () => {
    this.startDownloadLoader({ cancellable: false })
    setTimeout(() => {
      try {
        const { rupture = {}, translate } = this.props
        const { sectionsStoreTab } = this.state

        let csvContent = ''
        let fileName = 'lms_por_secao'

    if (sectionsStoreTab) {
      // Aba "Por Loja" - dados expandidos por loja e seção
      const storesList = rupture?.listLMPerStoreSections || rupture?.listLMPerSectionByStore || []

      // Cabeçalho do CSV: Loja, Seção, Quantidade de LMs, Porcentagem
      csvContent = `${translate('scheduleBlock.branchs')};${translate('ruptures.section')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

      // Se houver dados da API com a nova estrutura (listLMPerTop dentro de cada loja)
      if (storesList.length > 0 && storesList[0]?.listLMPerTop !== undefined) {
        storesList.forEach(store => {
          const storeName = store.dsBranch
            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
            : store.ds || store.name || store.idBranch || ''

          const sectionList = store.listLMPerTop || []
          sectionList.forEach(section => {
            const sectionName = section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || ''
            csvContent += `${storeName};${sectionName};${section.quantity || 0};${section.percent || 0}%\n`
          })
        })
      } else {
        // Fallback para estrutura antiga (sem listLMPerTop)
        storesList
          .filter(store => (store.quantity || 0) > 0)
          .forEach(store => {
            const storeName = store.ds || store.name || ''
            csvContent += `${storeName};;${store.quantity || 0};${store.percent || 0}%\n`
          })
      }

      fileName = 'lms_por_secao_por_loja'
    } else {
      // Aba "Por Seção"
      const rawList = rupture?.listLMPerSection || []

      // Remover duplicatas
      const sectionMap = new Map()
      rawList.forEach(section => {
        const key = section.cd || section.ds || ''
        if (!sectionMap.has(key)) {
          sectionMap.set(key, { ...section })
        }
      })
      const list = Array.from(sectionMap.values())

      // Ordenar por código numérico da seção (mesma ordem da tela)
      const sortedList = [...list].sort((a, b) => {
        const codeA = parseInt(a.cd) || 0
        const codeB = parseInt(b.cd) || 0
        return codeA - codeB
      })

      csvContent = `${translate('ruptures.section')};${translate('ruptures.lmQuantity')};${translate('percentage')}\n`

      sortedList.forEach(item => {
        const ds = item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || ''
        csvContent += `${ds};${item.quantity || 0};${item.percent || 0}%\n`
      })

      fileName = 'lms_por_secao'
    }

        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' })
        FileSaver.saveAs(blob, `${fileName}_${moment().format('YYYY-MM-DD_HH-mm')}.csv`)
      } finally {
        this.stopDownloadLoader()
      }
    }, 0)
  }

  /**
   * Gera CSV com os dados exibidos na tela para o quarto card (Perda de Receita)
   */
  generateCsvLossSales = () => {
    this.startDownloadLoader({ cancellable: false })
    setTimeout(() => {
      try {
        const { rupture = {}, translate } = this.props
        const { salesStoreTab } = this.state

        const currency = translate('option.currency')
        const sizeCurrency = parseInt(translate('size.currency'), 10) || 2
        const formatCurrency = {
          separator: translate('separator.currency'),
          delimiter: translate('delimiter.currency'),
        }

        let csvContent = ''
        let fileName = 'perda_receita'

    if (salesStoreTab) {
      // Aba "Por Loja" - dados expandidos por loja e seção
      const rawStoresList = rupture?.listRupturePerStore || rupture?.listRupturePerSectionByStore || []

      // Cabeçalho do CSV: Loja, Seção, Valor, Porcentagem
      csvContent = `${translate('scheduleBlock.branchs')};${translate('ruptures.section')};${translate('order_status.value')};${translate('percentage')}\n`

      // Se houver dados da API com a nova estrutura (listLMPerTop dentro de cada loja)
      if (rawStoresList.length > 0 && rawStoresList[0]?.listLMPerTop !== undefined) {
        // CORREÇÃO: Aplicar mesma lógica de arredondamento da tela
        // 1. Processar lojas com valores arredondados
        let processedStores = rawStoresList
          .filter(store => (store.total || store.quantity || 0) > 0)
          .map(store => {
            const storeName = store.dsBranch
              ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
              : store.ds || store.name || store.idBranch || ''

           
            const sectionsDetails = (store.listLMPerTop || [])
              .filter(section => (section.quantity || 0) > 0)
              .map(section => {
                const rawValue = section.quantity || 0
                const roundedValue = parseFloat(rawValue.toFixed(sizeCurrency))
                return {
                  name: section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || '',
                  value: roundedValue,
                  percent: section.percent || 0,
                }
              })

            
            const storeTotal = sectionsDetails.reduce((sum, s) => sum + s.value, 0)
            const finalTotal = parseFloat(storeTotal.toFixed(sizeCurrency))

            return {
              name: storeName,
              value: finalTotal,
              percent: store.percent || 0,
              sectionsDetails: sectionsDetails,
            }
          })

       
        if (processedStores.length > 0) {
          const totalBySection = this.totalLossOfSalesByStore
          const sumOfStores = processedStores.reduce((sum, store) => sum + store.value, 0)
          const roundedSum = parseFloat(sumOfStores.toFixed(sizeCurrency))
          const difference = parseFloat((totalBySection - roundedSum).toFixed(sizeCurrency))

          if (difference !== 0) {
          
            let maxIndex = 0
            let maxValue = 0
            processedStores.forEach((store, index) => {
              if (store.value > maxValue) {
                maxValue = store.value
                maxIndex = index
              }
            })

         
            processedStores = processedStores.map((store, index) => {
              if (index === maxIndex) {
                const adjustedValue = parseFloat((store.value + difference).toFixed(sizeCurrency))
                return {
                  ...store,
                  value: adjustedValue,
                }
              }
              return store
            })
          }
        }

        
        processedStores.forEach(store => {
          store.sectionsDetails.forEach(section => {
            const formattedValue = `${currency} ${Mask.toMoney(section.value.toFixed(sizeCurrency), formatCurrency)}`
            csvContent += `${store.name};${section.name};${formattedValue};${section.percent || 0}%\n`
          })
        })
      } else {
        // Fallback para estrutura antiga (sem listLMPerTop)
        rawStoresList
          .filter(store => (store.value || store.quantity || 0) > 0)
          .forEach(store => {
            const storeName = store.ds || store.name || store.branch || ''
            const formattedValue = `${currency} ${Mask.toMoney((store.value || store.quantity || 0).toFixed(sizeCurrency), formatCurrency)}`
            csvContent += `${storeName};;${formattedValue};${store.percent || 0}%\n`
          })
      }

      fileName = 'perda_receita_por_loja'
    } else {
      // Aba "Por Seção"
     
      const storeList = rupture?.listRupturePerStore || []
      let sortedList = []
      
      if (storeList.length > 0 && storeList[0]?.listLMPerTop !== undefined) {
      
        const sectionMap = new Map()
        
        storeList.forEach(store => {
          const sections = store.listLMPerTop || []
          sections.forEach(section => {
            const key = section.cd || section.ds || ''
            const rawValue = section.quantity || 0
            const roundedValue = parseFloat(rawValue.toFixed(sizeCurrency))
            
            if (sectionMap.has(key)) {
              const existing = sectionMap.get(key)
              existing.value = parseFloat((existing.value + roundedValue).toFixed(sizeCurrency))
            } else {
              sectionMap.set(key, {
                cd: section.cd,
                ds: section.ds,
                value: roundedValue,
                percent: section.percent || 0,
              })
            }
          })
        })
        
        const list = Array.from(sectionMap.values())
        
    
        const total = list.reduce((sum, item) => sum + item.value, 0)
        list.forEach(item => {
          if (total > 0) {
            item.percent = parseFloat(((item.value / total) * 100).toFixed(2))
          }
        })
        
        sortedList = [...list].sort((a, b) => {
          const codeA = parseInt(a.cd) || 0
          const codeB = parseInt(b.cd) || 0
          return codeA - codeB
        })
      } else {
        
        const rawList = rupture?.listRupturePerSection || []

        const sectionMap = new Map()
        rawList.forEach(section => {
          const key = section.cd || section.ds || ''
          if (!sectionMap.has(key)) {
            sectionMap.set(key, { ...section })
          }
        })
        const list = Array.from(sectionMap.values())

        sortedList = [...list].sort((a, b) => {
          const codeA = parseInt(a.cd) || 0
          const codeB = parseInt(b.cd) || 0
          return codeA - codeB
        }).map(item => ({
          cd: item.cd,
          ds: item.ds,
          value: item.quantity || item.value || 0,
          percent: item.percent || 0,
        }))
      }

      csvContent = `${translate('ruptures.section')};${translate('ruptures.estimatedLoss').replace('{0}', currency)};${translate('percentage')}\n`

      sortedList.forEach(item => {
        const ds = item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || ''
        const formattedValue = `${currency} ${Mask.toMoney(item.value.toFixed(sizeCurrency), formatCurrency)}`
        csvContent += `${ds};${formattedValue};${item.percent || 0}%\n`
      })

      fileName = 'perda_receita_por_secao'
    }

        const blob = new Blob(['\ufeff' + csvContent], { type: 'text/csv;charset=utf-8' })
        FileSaver.saveAs(blob, `${fileName}_${moment().format('YYYY-MM-DD_HH-mm')}.csv`)
      } finally {
        this.stopDownloadLoader()
      }
    }, 0)
  }

  closeModal = () => {
    this.setState({
      detailsMode: null,
    })
  }

  get storesWithOccurrencesCount() {
    const { rupture = {} } = this.props
    const { formData } = this.state

    // Se houver dados da API com a nova estrutura, contar lojas com total > 0
    if (rupture?.listLMPerStore && rupture.listLMPerStore.length > 0) {
      return rupture.listLMPerStore.filter(store => (store.total || store.quantity || 0) > 0).length
    }

    // Se não houver dados da API, calcular a partir dos dados disponíveis
    if (rupture && formData?.locationId && rupture.total > 0) {
      const storesList = this.groupDataByStore(rupture, formData)
      return storesList.filter(store => (store.quantity || 0) > 0).length
    }

    return 0
  }

  get compactTableDataForTotal() {
    const { translate, rupture = {} } = this.props
    const list = rupture.listLMPerTop || []

    return {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'quantity',
          centerData: true,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: list.map((item) => ({
        ds: item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || '',
        quantity: item.quantity || 0,
        percent: item.percent || 0,
      })),
    }
  }

  get compactTableDataForTotalByStore() {
    const { translate, rupture = {} } = this.props
    // Se houver dados de lojas, usar; caso contrário, criar estrutura vazia
    const list = rupture.listLMPerStore || []

    return {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'quantity',
          centerData: true,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: list.map((item) => {
        // Nova estrutura do backend: idBranch, dsBranch, total, percent, listLMPerTop
        const storeName = item.dsBranch 
          ? `${item.idBranch || ''} ${item.dsBranch}`.trim()
          : item.ds || item.name || item.idBranch || ''
        
        return {
          ds: storeName,
          quantity: item.total || item.quantity || 0,
          percent: item.percent || 0,
        }
      }),
    }
  }

  compactTableAccordionDataMock(data, isSales = false) {
    const { translate } = this.props
    const currency = translate('option.currency')
    const sizeCurrency = parseInt(translate('size.currency'), 10) || 2
    const formatCurrency = {
      separator: translate('separator.currency'),
      delimiter: translate('delimiter.currency'),
    }

    const result = {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: isSales ? 'value' : 'quantity',
          centerData: true,
          parsingFn: isSales
            ? (v) => `${currency} ${Mask.toMoney(
                (v || 0).toFixed(sizeCurrency),
                formatCurrency
              )}`
            : undefined,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: data ?? []
    }
    return result
  }

  // Função específica para o quarto card (Perda de Receita) seguindo padrão do código 8
  compactTableAccordionDataMockSales(data) {
    const { translate } = this.props
    const currency = translate('option.currency')
    const sizeCurrency = parseInt(translate('size.currency'), 10) || 2
    const formatCurrency = {
      separator: translate('separator.currency'),
      delimiter: translate('delimiter.currency'),
    }
    
    return {
      hideHeader: true,
      columns: [
        {
          selector: 'sections',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'value',
          centerData: true,
          parsingFn: (v) => {
            const numValue = parseFloat(v) || 0
            return `${currency} ${Mask.toMoney(
              numValue.toFixed(sizeCurrency),
              formatCurrency
            )}`
          },
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: data ?? []
    }
  }

  // Agrupa dados por loja baseado nos dados disponíveis
  groupDataByStore(ruptureData, formData) {
    if (!ruptureData || !formData?.locationId) {
      return []
    }

    // Criar mapa de códigos de loja para labels (nomes completos)
    const branchLabelMap = {}
    if (Array.isArray(formData.locationId)) {
      formData.locationId.forEach(branch => {
        if (branch.value && branch.label) {
          branchLabelMap[branch.value] = branch.label
        }
      })
    }

    // Obter lista de lojas selecionadas
    const branches = this.formatBranchs(formData.locationId)
    const rawListLMPerSection = ruptureData.listLMPerSection || []
    const total = ruptureData.total || 0

    // Remover seções duplicadas, agrupando por código (cd) e somando as quantidades
    const sectionMap = new Map()
    rawListLMPerSection.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMap.has(key)) {
        sectionMap.set(key, { ...section })
      }
    })
    const listLMPerSection = Array.from(sectionMap.values())

    if (branches.length === 0 || total === 0) {
      return []
    }

    // Usar o total real de LMs (rupture.total)
    const totalQuantity = total

    // Calcular quantidade total de LMs por seção para distribuição proporcional
    const totalSectionQuantity = listLMPerSection.reduce((sum, section) => sum + (section.quantity || 0), 0)
    const listLMPerTop = ruptureData.listLMPerTop || []
    const totalTopQuantity = listLMPerTop.reduce((sum, item) => sum + (item.quantity || 0), 0)
    
    // Usar o total de TOP como referência (que é o que aparece na tab Por TOP)
    const effectiveTotal = totalTopQuantity > 0 ? totalTopQuantity : totalQuantity
    
    // Calcular o fator de correção se listLMPerSection tiver soma diferente
    const correctionFactor = totalSectionQuantity > 0 && totalTopQuantity > 0 
      ? totalTopQuantity / totalSectionQuantity 
      : 1

    // Criar estrutura de dados por loja
    const storesList = branches.map((branchId, index) => {
      // Distribuir as seções proporcionalmente entre as lojas
      // Calcular quantidade total desta loja somando as quantidades das seções
      let storeQuantity = 0
      const storeDetails = listLMPerSection.map(section => {
        const sectionQuantity = section.quantity || 0
        // Aplicar fator de correção para garantir que a soma total seja igual ao total de TOP
        const correctedSectionQuantity = Math.round(sectionQuantity * correctionFactor)
        // Distribuir a quantidade da seção entre as lojas
        const sectionQuantityPerStore = Math.floor(correctedSectionQuantity / branches.length)
        const sectionRemainder = correctedSectionQuantity - (sectionQuantityPerStore * branches.length)
        // Última loja recebe o resto para garantir que a soma seja correta
        const finalQuantity = index === branches.length - 1 
          ? sectionQuantityPerStore + sectionRemainder 
          : sectionQuantityPerStore
        
        storeQuantity += finalQuantity
        
        const sectionPercent = effectiveTotal > 0 
          ? ((finalQuantity / effectiveTotal) * 100).toFixed(2) 
          : 0

        return {
          ds: section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || '',
          quantity: finalQuantity,
          percent: parseFloat(sectionPercent),
        }
      })
      
      // Calcular percentual da loja baseado no total
      const storePercent = effectiveTotal > 0 
        ? ((storeQuantity / effectiveTotal) * 100).toFixed(2) 
        : 0

      // Usar o nome completo da loja se disponível, caso contrário usar apenas o código
      const branchLabel = branchLabelMap[branchId] || branchId
      const displayName = branchLabelMap[branchId] ? branchLabel : `Loja ${branchId}`

      return {
        id: branchId,
        ds: displayName,
        name: displayName,
        quantity: storeQuantity,
        percent: parseFloat(storePercent),
        storeDetails: storeDetails,
      }
    })
    
    // Garantir que a soma total seja exatamente igual ao total de TOP
    const totalCalculated = storesList.reduce((sum, store) => sum + (store.quantity || 0), 0)
    const difference = effectiveTotal - totalCalculated
    
    // Ajustar a última loja para garantir que a soma total seja exata
    if (difference !== 0 && storesList.length > 0) {
      const lastStore = storesList[storesList.length - 1]
      lastStore.quantity += difference
      // Recalcular percentual da última loja
      lastStore.percent = effectiveTotal > 0 
        ? parseFloat(((lastStore.quantity / effectiveTotal) * 100).toFixed(2))
        : 0
    }

    // Ordenar lojas numericamente pelo código (id)
    storesList.sort((a, b) => {
      const idA = parseInt(a.id) || 0
      const idB = parseInt(b.id) || 0
      return idA - idB
    })

    return storesList
  }

  // Agrupa dados por loja usando TOP ao invés de seções
  groupDataByStoreForTop(ruptureData, formData) {
    if (!ruptureData || !formData?.locationId) {
      return []
    }

    // Criar mapa de códigos de loja para labels (nomes completos)
    const branchLabelMap = {}
    if (Array.isArray(formData.locationId)) {
      formData.locationId.forEach(branch => {
        if (branch.value && branch.label) {
          branchLabelMap[branch.value] = branch.label
        }
      })
    }

    // Obter lista de lojas selecionadas
    const branches = this.formatBranchs(formData.locationId)
    const listLMPerTop = ruptureData.listLMPerTop || []
    
    // Filtrar apenas TOPs com quantidade > 0
    const filteredTopList = listLMPerTop.filter(item => (item.quantity || 0) > 0)


    if (branches.length === 0 || filteredTopList.length === 0) {
      return []
    }

    // Calcular total de TOPs (apenas os com quantidade > 0)
    const totalTopQuantity = filteredTopList.reduce((sum, item) => sum + (item.quantity || 0), 0)
    const effectiveTotal = totalTopQuantity

    // Criar estrutura de dados por loja
    const storesList = branches.map((branchId, index) => {
      let storeQuantity = 0
      // Distribuir cada TOP igualmente entre as lojas
      const storeDetails = filteredTopList.map(topItem => {
        const topQuantity = topItem.quantity || 0
        // Distribuir a quantidade do TOP entre as lojas
        const topQuantityPerStore = Math.floor(topQuantity / branches.length)
        const topRemainder = topQuantity - (topQuantityPerStore * branches.length)
        // Última loja recebe o resto para garantir que a soma seja correta
        const finalQuantity = index === branches.length - 1 
          ? topQuantityPerStore + topRemainder 
          : topQuantityPerStore
        
        storeQuantity += finalQuantity
        
        const topPercent = effectiveTotal > 0 
          ? ((finalQuantity / effectiveTotal) * 100).toFixed(2) 
          : 0

        return {
          ds: topItem.cd ? `TOP ${topItem.cd} - ${topItem.ds || ''}` : topItem.ds ? `TOP ${topItem.ds}` : '',
          quantity: finalQuantity,
          percent: parseFloat(topPercent),
        }
      }).filter(detail => detail.quantity > 0) // Filtrar apenas detalhes com quantidade > 0
      
      // Calcular percentual da loja baseado no total
      const storePercent = effectiveTotal > 0 
        ? ((storeQuantity / effectiveTotal) * 100).toFixed(2) 
        : 0

      // Usar o nome completo da loja se disponível
      const branchLabel = branchLabelMap[branchId] || branchId
      const displayName = branchLabelMap[branchId] ? branchLabel : `Loja ${branchId}`

      return {
        id: branchId,
        ds: displayName,
        name: displayName,
        quantity: storeQuantity,
        percent: parseFloat(storePercent),
        storeDetails: storeDetails,
      }
    }).filter(store => store.quantity > 0) // Filtrar apenas lojas com quantidade > 0
    
    // Garantir que a soma total seja exatamente igual ao total de TOP
    const totalCalculated = storesList.reduce((sum, store) => sum + (store.quantity || 0), 0)
    const difference = effectiveTotal - totalCalculated
    
    // Ajustar a última loja para garantir que a soma total seja exata
    if (difference !== 0 && storesList.length > 0) {
      const lastStore = storesList[storesList.length - 1]
      lastStore.quantity += difference
      // Recalcular percentual da última loja
      lastStore.percent = effectiveTotal > 0 
        ? parseFloat(((lastStore.quantity / effectiveTotal) * 100).toFixed(2))
        : 0
    }

    // Ordenar lojas numericamente pelo código (id)
    storesList.sort((a, b) => {
      const idA = parseInt(a.id) || 0
      const idB = parseInt(b.id) || 0
      return idA - idB
    })

    return storesList
  }

  // Agrupa dados por loja usando TOP 2500 ao invés de seções
  groupDataByStoreForTop2500(ruptureData, formData) {
    if (!ruptureData || !formData?.locationId) {
      return []
    }


    // Criar mapa de códigos de loja para labels (nomes completos)
    const branchLabelMap = {}
    if (Array.isArray(formData.locationId)) {
      formData.locationId.forEach(branch => {
        if (branch.value && branch.label) {
          branchLabelMap[branch.value] = branch.label
        }
      })
    }

    // Obter lista de lojas selecionadas
    const branches = this.formatBranchs(formData.locationId)
    const rawListLMPerSectionTopThousand = ruptureData.listLMPerSectionTopThousand || []
    
    // Remover seções duplicadas, agrupando por código (cd) e somando as quantidades
    const sectionMap = new Map()
    rawListLMPerSectionTopThousand.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMap.has(key)) {
        sectionMap.set(key, { ...section })
      }
    })
    const listLMPerSectionTopThousand = Array.from(sectionMap.values())
    
    // Filtrar apenas seções TOP 2500 com quantidade > 0
    const filteredTop2500List = listLMPerSectionTopThousand.filter(item => (item.quantity || 0) > 0)
    
   
    if (branches.length === 0 || filteredTop2500List.length === 0) {
      return []
    }

    // Calcular total de TOP 2500 (apenas os com quantidade > 0)
    const totalTop2500Quantity = filteredTop2500List.reduce((sum, item) => sum + (item.quantity || 0), 0)
    const effectiveTotal = totalTop2500Quantity

    // Criar estrutura de dados por loja
    const storesList = branches.map((branchId, index) => {
      let storeQuantity = 0
      // Distribuir cada TOP 2500 igualmente entre as lojas
      const storeDetails = filteredTop2500List.map(top2500Item => {
        const top2500Quantity = top2500Item.quantity || 0
        // Distribuir a quantidade do TOP 2500 entre as lojas
        const top2500QuantityPerStore = Math.floor(top2500Quantity / branches.length)
        const top2500Remainder = top2500Quantity - (top2500QuantityPerStore * branches.length)
        // Última loja recebe o resto para garantir que a soma seja correta
        const finalQuantity = index === branches.length - 1 
          ? top2500QuantityPerStore + top2500Remainder 
          : top2500QuantityPerStore
        
        storeQuantity += finalQuantity
        
        const top2500Percent = effectiveTotal > 0 
          ? ((finalQuantity / effectiveTotal) * 100).toFixed(2) 
          : 0

        return {
          ds: top2500Item.cd ? `TOP ${top2500Item.cd} - ${top2500Item.ds || ''}` : top2500Item.ds ? `TOP ${top2500Item.ds}` : '',
          quantity: finalQuantity,
          percent: parseFloat(top2500Percent),
        }
      }).filter(detail => detail.quantity > 0) // Filtrar apenas detalhes com quantidade > 0
      
      // Calcular percentual da loja baseado no total
      const storePercent = effectiveTotal > 0 
        ? ((storeQuantity / effectiveTotal) * 100).toFixed(2) 
        : 0

      // Usar o nome completo da loja se disponível
      const branchLabel = branchLabelMap[branchId] || branchId
      const displayName = branchLabelMap[branchId] ? branchLabel : `Loja ${branchId}`

      return {
        id: branchId,
        ds: displayName,
        name: displayName,
        quantity: storeQuantity,
        percent: parseFloat(storePercent),
        storeDetails: storeDetails,
      }
    }).filter(store => store.quantity > 0) // Filtrar apenas lojas com quantidade > 0
    
    // Garantir que a soma total seja exatamente igual ao total de TOP 2500
    const totalCalculated = storesList.reduce((sum, store) => sum + (store.quantity || 0), 0)
    const difference = effectiveTotal - totalCalculated
    
    // Ajustar a última loja para garantir que a soma total seja exata
    if (difference !== 0 && storesList.length > 0) {
      const lastStore = storesList[storesList.length - 1]
      lastStore.quantity += difference
      // Recalcular percentual da última loja
      lastStore.percent = effectiveTotal > 0 
        ? parseFloat(((lastStore.quantity / effectiveTotal) * 100).toFixed(2))
        : 0
    }

    // Ordenar lojas numericamente pelo código (id)
    storesList.sort((a, b) => {
      const idA = parseInt(a.id) || 0
      const idB = parseInt(b.id) || 0
      return idA - idB
    })

    return storesList
  }

  // Normaliza dados de loja para garantir que sempre tenham storeDetails
  // Distribui as seções igualmente entre as lojas, como faz groupDataByStoreForSection
  normalizeStoreDataWithDetails(storesList, sectionList, isSales = false) {
    if (!storesList || storesList.length === 0 || !sectionList || sectionList.length === 0) {
      return storesList || []
    }

    // Verificar se os dados já têm storeDetails
    const hasStoreDetails = storesList.some(store => store.storeDetails && store.storeDetails.length > 0)
    
    if (hasStoreDetails) {
      return storesList
    }

    // Calcular storeDetails para cada loja a partir das seções
    // Distribuir igualmente entre as lojas (mesma lógica do groupDataByStoreForSection)
    const total = sectionList.reduce((sum, item) => sum + (item.quantity || item.value || 0), 0)
    const storesCount = storesList.length
    
    return storesList.map((store, index) => {
      const storeDetails = sectionList.map(section => {
        const sectionQuantity = section.quantity || section.value || 0
        // Distribuir a quantidade da seção entre as lojas preservando decimais
        const sectionQuantityPerStore = sectionQuantity / storesCount
        // Calcular o resto para ajustar na última loja
        const accumulatedPerStore = sectionQuantityPerStore * storesCount
        const sectionRemainder = sectionQuantity - accumulatedPerStore
        // Última loja recebe o resto para garantir que a soma seja exata
        const finalQuantity = index === storesCount - 1 
          ? sectionQuantityPerStore + sectionRemainder 
          : sectionQuantityPerStore
        
        // Arredondar para 2 casas decimais para valores monetários
        const roundedQuantity = isSales 
          ? Math.round(finalQuantity * 100) / 100
          : Math.round(finalQuantity)
        
        const sectionPercent = total > 0 
          ? ((roundedQuantity / total) * 100).toFixed(2) 
          : 0

        return {
          ds: section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || '',
          quantity: isSales ? undefined : roundedQuantity,
          value: isSales ? roundedQuantity : undefined,
          percent: parseFloat(sectionPercent),
        }
      })

      return {
        ...store,
        storeDetails,
      }
    })
  }

  // Agrupa dados por loja usando Seções
  groupDataByStoreForSections(ruptureData, formData) {
    if (!ruptureData || !formData?.locationId) {
      return []
    }

    // Criar mapa de códigos de loja para labels (nomes completos)
    const branchLabelMap = {}
    if (Array.isArray(formData.locationId)) {
      formData.locationId.forEach(branch => {
        if (branch.value && branch.label) {
          branchLabelMap[branch.value] = branch.label
        }
      })
    }

    // Obter lista de lojas selecionadas
    const branches = this.formatBranchs(formData.locationId)
    const rawListLMPerSection = ruptureData.listLMPerSection || []
    
    // Remover seções duplicadas, agrupando por código (cd) e somando as quantidades
    const sectionMap = new Map()
    rawListLMPerSection.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMap.has(key)) {
        sectionMap.set(key, { ...section })
      }
    })
    const listLMPerSection = Array.from(sectionMap.values())
    
    // Filtrar apenas seções com quantidade > 0
    const filteredSectionList = listLMPerSection.filter(item => (item.quantity || 0) > 0)
    
   

    if (branches.length === 0 || filteredSectionList.length === 0) {
      return []
    }

    // Calcular total de seções (apenas as com quantidade > 0)
    const totalSectionQuantity = filteredSectionList.reduce((sum, item) => sum + (item.quantity || 0), 0)
    const effectiveTotal = totalSectionQuantity

    // Criar estrutura de dados por loja
    const storesList = branches.map((branchId, index) => {
      let storeQuantity = 0
      // Distribuir cada seção igualmente entre as lojas
      const storeDetails = filteredSectionList.map(sectionItem => {
        const sectionQuantity = sectionItem.quantity || 0
        // Distribuir a quantidade da seção entre as lojas
        const sectionQuantityPerStore = Math.floor(sectionQuantity / branches.length)
        const sectionRemainder = sectionQuantity - (sectionQuantityPerStore * branches.length)
        // Última loja recebe o resto para garantir que a soma seja correta
        const finalQuantity = index === branches.length - 1 
          ? sectionQuantityPerStore + sectionRemainder 
          : sectionQuantityPerStore
        
        storeQuantity += finalQuantity
        
        const sectionPercent = effectiveTotal > 0 
          ? ((finalQuantity / effectiveTotal) * 100).toFixed(2) 
          : 0

        return {
          ds: sectionItem.cd ? `${sectionItem.cd} - ${sectionItem.ds || ''}` : sectionItem.ds || '',
          quantity: finalQuantity,
          percent: parseFloat(sectionPercent),
        }
      }).filter(detail => detail.quantity > 0) // Filtrar apenas detalhes com quantidade > 0
      
      // Calcular percentual da loja baseado no total
      const storePercent = effectiveTotal > 0 
        ? ((storeQuantity / effectiveTotal) * 100).toFixed(2) 
        : 0

      // Usar o nome completo da loja se disponível
      const branchLabel = branchLabelMap[branchId] || branchId
      const displayName = branchLabelMap[branchId] ? branchLabel : `Loja ${branchId}`

      return {
        id: branchId,
        ds: displayName,
        name: displayName,
        quantity: storeQuantity,
        percent: parseFloat(storePercent),
        storeDetails: storeDetails,
      }
    }).filter(store => store.quantity > 0) // Filtrar apenas lojas com quantidade > 0
    
    // Garantir que a soma total seja exatamente igual ao total de seções
    const totalCalculated = storesList.reduce((sum, store) => sum + (store.quantity || 0), 0)
    const difference = effectiveTotal - totalCalculated
    
    // Ajustar a última loja para garantir que a soma total seja exata
    if (difference !== 0 && storesList.length > 0) {
      const lastStore = storesList[storesList.length - 1]
      lastStore.quantity += difference
      // Recalcular percentual da última loja
      lastStore.percent = effectiveTotal > 0 
        ? parseFloat(((lastStore.quantity / effectiveTotal) * 100).toFixed(2))
        : 0
    }

    // Ordenar lojas numericamente pelo código (id)
    storesList.sort((a, b) => {
      const idA = parseInt(a.id) || 0
      const idB = parseInt(b.id) || 0
      return idA - idB
    })

   

    return storesList
  }

  // Agrupa dados por loja para seções específicas (TOP2500, Sections, Sales)
  groupDataByStoreForSection(ruptureData, formData, sectionList) {
    if (!ruptureData || !formData?.locationId || !sectionList || sectionList.length === 0) {
      return []
    }

    // Criar mapa de códigos de loja para labels (nomes completos)
    const branchLabelMap = {}
    if (Array.isArray(formData.locationId)) {
      formData.locationId.forEach(branch => {
        if (branch.value && branch.label) {
          branchLabelMap[branch.value] = branch.label
        }
      })
    }

    // Obter lista de lojas selecionadas
    const branches = this.formatBranchs(formData.locationId)
    const total = sectionList.reduce((sum, item) => sum + (item.quantity || item.value || 0), 0)

    if (branches.length === 0 || total === 0) {
      return []
    }

    const effectiveTotal = total

    // Criar estrutura de dados por loja
    const storesList = branches.map((branchId, index) => {
      let storeQuantity = 0
      const storeDetails = sectionList.map(section => {
        const sectionQuantity = section.quantity || section.value || 0
        // Distribuir a quantidade da seção entre as lojas preservando decimais
        // Para valores monetários, usar divisão direta e ajustar na última loja
        const sectionQuantityPerStore = sectionQuantity / branches.length
        // Calcular o resto para ajustar na última loja
        const accumulatedPerStore = sectionQuantityPerStore * branches.length
        const sectionRemainder = sectionQuantity - accumulatedPerStore
        // Última loja recebe o resto para garantir que a soma seja exata
        const finalQuantity = index === branches.length - 1 
          ? sectionQuantityPerStore + sectionRemainder 
          : sectionQuantityPerStore
        
        // Arredondar para 2 casas decimais para valores monetários
        const roundedQuantity = Math.round(finalQuantity * 100) / 100
        
        storeQuantity += roundedQuantity
        
        const sectionPercent = effectiveTotal > 0 
          ? ((roundedQuantity / effectiveTotal) * 100).toFixed(2) 
          : 0

        return {
          ds: section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || '',
          quantity: roundedQuantity,
          value: roundedQuantity, // Para compatibilidade com Sales
          percent: parseFloat(sectionPercent),
        }
      })
      
      // Arredondar quantidade total da loja para 2 casas decimais
      const roundedStoreQuantity = Math.round(storeQuantity * 100) / 100
      
      // Calcular percentual da loja baseado no total
      const storePercent = effectiveTotal > 0 
        ? ((roundedStoreQuantity / effectiveTotal) * 100).toFixed(2) 
        : 0

      // Usar o nome completo da loja se disponível
      const branchLabel = branchLabelMap[branchId] || branchId
      const displayName = branchLabelMap[branchId] ? branchLabel : `Loja ${branchId}`

      return {
        id: branchId,
        ds: displayName,
        name: displayName,
        quantity: roundedStoreQuantity,
        value: roundedStoreQuantity, // Para compatibilidade com Sales
        percent: parseFloat(storePercent),
        storeDetails: storeDetails,
      }
    })
    
    // Garantir que a soma total seja exatamente igual ao total (com precisão de 2 casas decimais)
    const totalCalculated = storesList.reduce((sum, store) => sum + (store.quantity || 0), 0)
    const roundedTotalCalculated = Math.round(totalCalculated * 100) / 100
    const difference = effectiveTotal - roundedTotalCalculated
    
    // Ajustar a última loja para garantir que a soma total seja exata
    if (Math.abs(difference) > 0.01 && storesList.length > 0) {
      const lastStore = storesList[storesList.length - 1]
      const adjustedQuantity = Math.round((lastStore.quantity + difference) * 100) / 100
      lastStore.quantity = adjustedQuantity
      lastStore.value = adjustedQuantity
      lastStore.percent = effectiveTotal > 0 
        ? parseFloat(((adjustedQuantity / effectiveTotal) * 100).toFixed(2))
        : 0
    }

    // Ordenar lojas numericamente pelo código (id)
    storesList.sort((a, b) => {
      const idA = parseInt(a.id) || 0
      const idB = parseInt(b.id) || 0
      return idA - idB
    })

    return storesList
  }

  // Agrupa dados por loja usando Perda de Receita (Sales)
  // NOTA: Esta função não deve ser usada para o quarto card, pois não devemos dividir valores
  // Os valores devem vir diretamente da API atribuídos às lojas correspondentes
  groupDataByStoreForSales(ruptureData, formData) {
    // Para o quarto card, não devemos calcular dividindo valores
    // Os dados devem vir diretamente da API (listRupturePerSectionByStore)
    // Retornar array vazio para forçar uso dos dados da API
    return []
  }

  get compactTableDataForTop2500ByStore() {
    const { translate, rupture = {} } = this.props
    // Nova estrutura: listLMPerStoreTopThousand, estrutura antiga: listLMPerSectionTopThousandByStore
    const list = rupture.listLMPerStoreTopThousand || rupture.listLMPerSectionTopThousandByStore || []

    return {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'quantity',
          centerData: true,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: list.map((item) => ({
        ds: item.ds || item.name || '',
        quantity: item.quantity || 0,
        percent: item.percent || 0,
      })),
    }
  }

  get compactTableDataForSectionsByStore() {
    const { translate, rupture = {} } = this.props
    // Nova estrutura: listLMPerStoreSections, estrutura antiga: listLMPerSectionByStore
    const list = rupture.listLMPerStoreSections || rupture.listLMPerSectionByStore || []

    return {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'quantity',
          centerData: true,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: list.map((item) => ({
        ds: item.ds || item.name || '',
        quantity: item.quantity || 0,
        percent: item.percent || 0,
      })),
    }
  }

  get compactTableDataForLossSalesByStore() {
    const { translate, rupture = {} } = this.props
    const currency = translate('option.currency')
    const sizeCurrency = parseInt(translate('size.currency'), 10) || 2
    const formatCurrency = {
      separator: translate('separator.currency'),
      delimiter: translate('delimiter.currency'),
    }
    // Nova estrutura: listRupturePerStore, estrutura antiga: listRupturePerSectionByStore
    const list = rupture.listRupturePerStore || rupture.listRupturePerSectionByStore || []

    return {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'value',
          centerData: true,
          parsingFn: (v) =>
            `${currency} ${Mask.toMoney(
              v.toFixed(sizeCurrency),
              formatCurrency
            )}`,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: list.map((item) => ({
        ds: item.ds || item.name || '',
        value: item.quantity || item.value || 0,
        percent: item.percent || 0,
      })),
    }
  }

  get totalLossOfSales() {
    const { rupture = {} } = this.props
    const listBySection = rupture.listRupturePerSection || []

    // Soma os valores de todas as linhas da coluna "R$ estimado de perda" da tabela "Por TOP"
    const total = listBySection.reduce((sum, item) => {
      const value = parseFloat(item.quantity) || parseFloat(item.value) || 0
      return sum + value
    }, 0)

    return total
  }

  get totalLMsBySection() {
    const { rupture = {} } = this.props
    const rawListLMPerSection = rupture.listLMPerSection || []

    // Remover seções duplicadas, mantendo apenas a primeira ocorrência de cada seção
    const sectionMap = new Map()
    rawListLMPerSection.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMap.has(key)) {
        sectionMap.set(key, { ...section })
      }
    })
    const listLMPerSection = Array.from(sectionMap.values())

    // Conta a quantidade de seções com quantity diferente de 0
    const count = listLMPerSection.filter(item => {
      const quantity = parseFloat(item.quantity) || 0
      return quantity !== 0
    }).length

    return count
  }

  get totalLossOfSalesByStore() {
    const { rupture = {}, translate } = this.props
    const sizeCurrency = parseInt(translate('size.currency'), 10) || 2
    const storeList = rupture?.listRupturePerStore || []
    
    if (storeList.length > 0 && storeList[0]?.listLMPerTop !== undefined) {
      let total = 0
      storeList.forEach(store => {
        const sections = store.listLMPerTop || []
        sections.forEach(section => {
          const rawValue = section.quantity || 0
          const roundedValue = parseFloat(rawValue.toFixed(sizeCurrency))
          total += roundedValue
        })
      })
      return parseFloat(total.toFixed(sizeCurrency))
    }
    

    const rawList = rupture?.listRupturePerSection || []

    // Remover seções duplicadas, mantendo apenas a primeira ocorrência de cada seção
    const sectionMap = new Map()
    rawList.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMap.has(key)) {
        sectionMap.set(key, { ...section })
      }
    })
    const list = Array.from(sectionMap.values())

    // Soma os valores de todas as linhas da coluna "R$ estimado de perda"
    const total = list.reduce((sum, item) => {
      const value = parseFloat(item.quantity) || parseFloat(item.value) || 0
      const roundedValue = parseFloat(value.toFixed(sizeCurrency))
      return sum + roundedValue
    }, 0)

    return parseFloat(total.toFixed(sizeCurrency))
  }

  get compactTableDataForTop2500() {
    const { translate, rupture = {} } = this.props
    const rawList = rupture.listLMPerSectionTopThousand || []

    // Remover seções duplicadas, mantendo apenas a primeira ocorrência de cada seção
    const sectionMap = new Map()
    rawList.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMap.has(key)) {
        sectionMap.set(key, { ...section })
      }
    })
    const list = Array.from(sectionMap.values())

    // Ordenar por código numérico da seção
    const sortedList = [...list].sort((a, b) => {
      const codeA = parseInt(a.cd) || 0
      const codeB = parseInt(b.cd) || 0
      return codeA - codeB
    })

    return {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'quantity',
          centerData: true,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: sortedList.map((item) => ({
        ds: item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || '',
        quantity: item.quantity || 0,
        percent: item.percent || 0,
      })),
    }
  }

  get compactTableDataForSections() {
    const { translate, rupture = {} } = this.props
    const rawList = rupture.listLMPerSection || []

    // Remover seções duplicadas, mantendo apenas a primeira ocorrência de cada seção
    const sectionMap = new Map()
    rawList.forEach(section => {
      const key = section.cd || section.ds || ''
      if (!sectionMap.has(key)) {
        sectionMap.set(key, { ...section })
      }
    })
    const list = Array.from(sectionMap.values())

    // Ordenar por código numérico da seção
    const sortedList = [...list].sort((a, b) => {
      const codeA = parseInt(a.cd) || 0
      const codeB = parseInt(b.cd) || 0
      return codeA - codeB
    })

    return {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'quantity',
          centerData: true,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: sortedList.map((item) => ({
        ds: item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || '',
        quantity: item.quantity || 0,
        percent: item.percent || 0,
      })),
    }
  }

  get compactTableDataForLossSales() {
    const { translate, rupture = {} } = this.props
    const currency = translate('option.currency')
    const sizeCurrency = parseInt(translate('size.currency'), 10) || 2
    const formatCurrency = {
      separator: translate('separator.currency'),
      delimiter: translate('delimiter.currency'),
    }
    
  
    const storeList = rupture?.listRupturePerStore || []
    let sortedList = []
    
    if (storeList.length > 0 && storeList[0]?.listLMPerTop !== undefined) {

      const sectionMap = new Map()
      
      storeList.forEach(store => {
        const sections = store.listLMPerTop || []
        sections.forEach(section => {
          const key = section.cd || section.ds || ''
          const rawValue = section.quantity || 0

          const roundedValue = parseFloat(rawValue.toFixed(sizeCurrency))
          
          if (sectionMap.has(key)) {
            const existing = sectionMap.get(key)
            existing.value = parseFloat((existing.value + roundedValue).toFixed(sizeCurrency))
          } else {
            sectionMap.set(key, {
              cd: section.cd,
              ds: section.ds,
              value: roundedValue,
              percent: section.percent || 0,
            })
          }
        })
      })
      
      const list = Array.from(sectionMap.values())
      

      const total = list.reduce((sum, item) => sum + item.value, 0)
      list.forEach(item => {
        if (total > 0) {
          item.percent = parseFloat(((item.value / total) * 100).toFixed(2))
        }
      })
      

      sortedList = [...list].sort((a, b) => {
        const codeA = parseInt(a.cd) || 0
        const codeB = parseInt(b.cd) || 0
        return codeA - codeB
      })
    } else {

      const rawList = rupture.listRupturePerSection || []

      // Remover seções duplicadas, mantendo apenas a primeira ocorrência de cada seção
      const sectionMap = new Map()
      rawList.forEach(section => {
        const key = section.cd || section.ds || ''
        if (!sectionMap.has(key)) {
          sectionMap.set(key, { ...section })
        }
      })
      const list = Array.from(sectionMap.values())

      // Ordenar por código numérico da seção
      sortedList = [...list].sort((a, b) => {
        const codeA = parseInt(a.cd) || 0
        const codeB = parseInt(b.cd) || 0
        return codeA - codeB
      })
      

      sortedList = sortedList.map(item => ({
        cd: item.cd,
        ds: item.ds,
        value: item.quantity || 0,
        percent: item.percent || 0,
      }))
    }

    return {
      hideHeader: true,
      columns: [
        {
          selector: 'ds',
          extraDataProps: {
            width: '50%',
          },
        },
        {
          selector: 'value',
          centerData: true,
          parsingFn: (v) =>
            `${currency} ${Mask.toMoney(
              v.toFixed(sizeCurrency),
              formatCurrency
            )}`,
          extraDataProps: {
            width: '25%',
          },
        },
        {
          selector: 'percent',
          centerData: true,
          parsingFn: (v) => `${v}%`,
          extraDataProps: {
            width: '25%',
          },
        },
      ],
      data: sortedList.map((item) => ({
        ds: item.cd ? `${item.cd} - ${item.ds || ''}` : item.ds || '',
        value: item.value,
        percent: item.percent || 0,
      })),
    }
  }

  render() {
    const { translate, rupture = {} } = this.props
    const { showReport, showFilters } = this.state

    const currency = translate('option.currency')
    const sizeCurrency = parseInt(translate('size.currency'), 10) || 2
    const formatCurrency = {
      separator: translate('separator.currency'),
      delimiter: translate('delimiter.currency'),
    }

    return (
      <section className='common-report new-code-8'>
        <div className='title'>
          <h1>{translate('rupture.header.title')}</h1>
        </div>

        <div className='content'>
          <div className={this.filtersOverlayClassnames} />
          <div className={this.filtersClassnames}>
            <div
              className='close'
              onClick={() =>
                this.setState({
                  showFilters: false,
                })
              }
            >
              <CloseSVG />
            </div>
            <h2>{translate('commonReport.filters')}</h2>
            <Form
              fields={this.formFields}
              onSubmit={(fd) => {
                this.handleFilterSubmit(fd)
              }}
              translate={translate}
            />
          </div>

          {showReport && (
            <div
              className='top'
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
              }}
            >
              <div className='left'>
                <div
                  className='period-filter card-box'
                  style={{
                    display: 'inline-block',
                    padding: '15px 25px',
                    width: '290px',
                    height: 'auto',
                    marginBottom: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'normal',
                  }}
                >
                  <span
                    style={{
                      fontSize: '16px',
                      fontWeight: 600,
                      color: '#585858',
                      marginBottom: '8px',
                      lineHeight: 'normal',
                      marginLeft: '-12px',
                    }}
                  >
                    {translate('field.period.hint')}
                  </span>
                  <span
                    style={{
                      fontWeight: 400,
                      fontSize: '21px',
                      lineHeight: '100%',
                      letterSpacing: '0px',
                      color: '#585858',
                      marginLeft: '-12px',
                      paddingBottom: '8px',
                    }}
                  >
                    {this.state.dateStartFiltered ||
                      moment().format('DD/MM/YYYY')}{' '}
                    -{' '}
                    {this.state.dateEndFiltered ||
                      moment().format('DD/MM/YYYY')}
                  </span>
                </div>
              </div>
              <div className='right'>
                <button onClick={() => this.getCsv()} className='btn download'>
                  <DownloadSVG className='default-relatory-svg' />
                  <span>{translate('commonReport.download')}</span>
                </button>
                <button
                  onClick={() =>
                    this.setState({
                      showFilters: true,
                    })
                  }
                  className='btn'
                >
                  <FilterSVG className='default-relatory-svg' />
                  <span>{translate('mobile.filter')}</span>
                </button>
              </div>
            </div>
          )}

          {showReport && (
            <div className='new-code-8-cards-wrapper'>
              <Card title={translate('ruptures.ruptureTitle')}>
                <br />
                <span className='big-number'>{rupture?.total || 0}</span>
                <span style={{ marginRight: '16px' }}>
                  {' '}
                  {translate('occurrences-code8.totalTitle')}{' '}
                </span>
                <span className='big-number'>
                  {this.storesWithOccurrencesCount}
                </span>
                <span> {translate('scheduleBlock.branchs')} </span>
                <br />
                <p>{translate('ruptures.ruptureText')}</p>
                <br />
                <button
                  onClick={() =>
                    this.setState({
                      detailsMode: RUPTURE_TYPE.TOTAL,
                      topStoreTab: false,
                    })
                  }
                  className='btn btn-secondary full-w'
                >
                  {translate('see.details')}
                </button>
              </Card>

              <Card title={translate('ruptures.heartTitle')}>
                <br />
                <span className='big-number'>{rupture?.topThousand || 0}</span>
                <span> {translate('commercialManagements.LMS')} </span>
                <br />
                <p>{translate('ruptures.heartText')}</p>
                <br />
                <button
                  onClick={() =>
                    this.setState({
                      detailsMode: RUPTURE_TYPE.TOP2500,
                      top2500StoreTab: false,
                    })
                  }
                  className='btn btn-secondary full-w'
                >
                  {translate('see.details')}
                </button>
              </Card>

              <Card title={translate('ruptures.sectionTitle.2')}>
                <br />
                <span className='big-number'>{this.totalLMsBySection || 0}</span>
                <br />
                <p>{translate('ruptures.sectionText')}</p>
                <br />
                <button
                  onClick={() =>
                    this.setState({
                      detailsMode: RUPTURE_TYPE.LMS,
                      sectionsStoreTab: false,
                    })
                  }
                  className='btn btn-secondary full-w'
                >
                  {translate('see.details')}
                </button>
              </Card>

              <Card title={translate('ruptures.lossSaleTitle')}>
                <br />
                <span className='big-number red'>
                  {this.totalLossOfSalesByStore > 0
                    ? `${currency} ${Mask.toMoney(
                        this.totalLossOfSalesByStore.toFixed(sizeCurrency),
                        formatCurrency
                      )}`
                    : `${currency} 0,00`}
                </span>
                <br />
                <p>{translate('ruptures.lossRevenueText')}</p>
                <br />
                <button
                  onClick={() =>
                    this.setState({
                      detailsMode: RUPTURE_TYPE.SALES,
                      salesStoreTab: false,
                    })
                  }
                  className='btn btn-secondary full-w'
                >
                  {translate('see.details')}
                </button>
              </Card>
            </div>
          )}

          {this.state.detailsMode === RUPTURE_TYPE.TOTAL && (
            <Modal
              className='code-8-modal'
              closeModal={this.closeModal}
              size='md'
            >
              <br />
              <div className='modal-title'>
                {translate('ruptures.ruptureTitle')}
              </div>
              <span className='big-number'>{rupture?.total || 0}</span>
              <br />
              {this.state.dateStartFiltered ||
                moment().format('DD/MM/YYYY')} -{' '}
              {this.state.dateEndFiltered || moment().format('DD/MM/YYYY')}
              <p>{translate('ruptures.ruptureText')}</p>
              <br />
              <NavTab
                onChange={(tab) => this.setState({ topStoreTab: !!tab })}
                defaultTab={0}
              >
                
                <Tab title={translate('ruptures.PerTop')}>
                  {(() => {
                    const list = rupture?.listLMPerTop || []
                    if (list.length === 0 || list.every(item => (item.quantity || 0) === 0)) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <p>Não há dados para o período selecionado.</p>
                        </div>
                      )
                    }
                    return (
                      <>
                        <table className='full-w text-left header-table'>
                          <thead>
                            <tr>
                              <td width='50%'>{translate('ruptures.top')}</td>
                              <td className='text-center' width='25%'>
                                {translate('ruptures.lmQuantity')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('percentage')}
                              </td>
                            </tr>
                          </thead>
                        </table>
                        <CompactTable {...this.compactTableDataForTotal} />
                      </>
                    )
                  })()}
                </Tab>
                <Tab title={translate('ocurr.code.8.by.store')}>
                  {(() => {
                  
                    // Se não houver dados por loja da API, calcular a partir dos dados disponíveis usando TOP
                    let storesList = rupture?.listLMPerStore || []
                    
                    // Se houver dados da API com a nova estrutura (listLMPerStore com listLMPerTop)
                    if (storesList.length > 0 && storesList[0]?.listLMPerTop !== undefined) {
                      // Converter a nova estrutura do backend para o formato esperado pelo componente
                    
                      storesList = storesList
                        .filter(store => (store.total || store.quantity || 0) > 0)
                        .map(store => {
                          // Formatar nome da loja: "idBranch - dsBranch"
                          const storeName = store.dsBranch 
                            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
                            : store.ds || store.name || store.idBranch || ''
                          
                          
                          const storeDetails = (store.listLMPerTop || [])
                            .filter(top => (top.quantity || 0) > 0)
                            .map(top => ({
                              ds: `TOP ${top.ds || ''}`,
                              quantity: top.quantity || 0,
                              percent: top.percent || 0,
                            }))
                          
                          return {
                            id: store.idBranch,
                            ds: storeName,
                            name: storeName,
                            quantity: store.total || store.quantity || 0,
                            percent: store.percent || 0,
                            storeDetails: storeDetails,
                          }
                        })
                    } else if (storesList.length > 0) {
                      // Formato antigo (compatibilidade): filtrar valores > 0 e formatar detalhes com "TOP"
                      storesList = storesList
                        .filter(store => (store.quantity || 0) > 0)
                        .map(store => {
                          // Se os detalhes vierem da API, filtrar apenas valores > 0 e adicionar "TOP" antes do número
                          const filteredDetails = (store.storeDetails || [])
                            .filter(detail => (detail.quantity || 0) > 0)
                            .map(detail => {
                              // Adicionar "TOP" antes do número se ainda não tiver
                              let formattedDs = detail.ds || ''
                              if (detail.cd) {
                                // Se tiver código, formatar como "TOP {cd} - {ds}"
                                formattedDs = `TOP ${detail.cd}${detail.ds ? ` - ${detail.ds}` : ''}`
                              } else if (detail.ds && !detail.ds.startsWith('TOP ')) {
                                // Se não tiver código mas tiver descrição e não começar com "TOP", adicionar
                                formattedDs = `TOP ${detail.ds}`
                              }
                              return {
                                ...detail,
                                ds: formattedDs,
                              }
                            })
                          return {
                            ...store,
                            storeDetails: filteredDetails,
                          }
                        })
                    } else if (rupture && this.state.formData?.locationId && rupture.total > 0) {
                      // Se não houver dados da API, calcular a partir dos dados disponíveis usando TOP
                      storesList = this.groupDataByStoreForTop(rupture, this.state.formData)
                    }
                    
                    // Ordenar lojas numericamente pelo código (id)
                    if (storesList.length > 0) {
                      storesList = [...storesList].sort((a, b) => {
                        // Tentar extrair o código numérico do id ou do início do ds
                        const getNumericId = (item) => {
                          if (item.id) {
                            const num = parseInt(item.id)
                            if (!isNaN(num)) return num
                          }
                          // Tentar extrair do início do ds (ex: "0004 - LOJA CONTAGEM" -> 4)
                          if (item.ds) {
                            const match = item.ds.match(/^(\d+)/)
                            if (match) {
                              const num = parseInt(match[1])
                              if (!isNaN(num)) return num
                            }
                          }
                          return 0
                        }
                        return getNumericId(a) - getNumericId(b)
                      })
                    }
                    
                    // Filtrar novamente para garantir que apenas lojas com quantidade > 0 sejam exibidas
                    storesList = storesList.filter(store => (store.total || store.quantity || 0) > 0)
                    
                    if (storesList.length === 0) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <p>Não há dados para o período selecionado.</p>
                        </div>
                      )
                    }
                    
                   
                    return (
                      <>
                        <table className='full-w text-center header-table'>
                          <thead>
                            <tr>
                              <td className='text-left' width='50%'>
                                {translate('scheduleBlock.branchs')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('ruptures.lmQuantity')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('percentage')}
                              </td>
                            </tr>
                          </thead>
                        </table>
                        {storesList.map((store, index) => {
                          const storeQuantity = store.total || store.quantity || 0
                          const storePercent = store.percent || 0
                          const storeName = store.ds || store.name || store.idBranch || ''
                          
                          return (
                            <Accordion
                              isNewComponent
                              key={store.id || store.idBranch || storeName || index}
                              size='sm'
                              title={
                                <AccordionTableTitleStores
                                  branch={storeName}
                                  quantity={storeQuantity}
                                  percentage={`${storePercent}%`}
                                />
                              }
                              className='margin-top no-margin-bottom accordion-box'
                            >
                              <CompactTable
                                {...this.compactTableAccordionDataMock((store.storeDetails || []).filter(detail => (detail.quantity || 0) > 0))}
                              />
                            </Accordion>
                          )
                        })}
                      </>
                    )
                  })()}
                </Tab>
              </NavTab>
              <div className='modal-buttons-footer'>
                <button
                  onClick={this.closeModal}
                  className='custom-modal-close-button'
                >
                  {translate('close_button_label')}
                </button>
                <ReportDownloadBtn
                  onReport={() => this.generateCsvFromScreenData()}
                  t={translate}
                />
              </div>
            </Modal>
          )}

          {this.state.detailsMode === RUPTURE_TYPE.TOP2500 && (
            <Modal
              className='code-8-modal'
              closeModal={this.closeModal}
              size='md'
            >
              <br />
              <div className='modal-title'>
                {translate('ruptures.heartTitle')}
              </div>
              <span className='big-number'>{rupture?.topThousand || 0}</span>
              <br />
              {this.state.dateStartFiltered ||
                moment().format('DD/MM/YYYY')} -{' '}
              {this.state.dateEndFiltered || moment().format('DD/MM/YYYY')}
              <p>{translate('ruptures.heartText')}</p>
              <br />
              <NavTab
                onChange={(tab) => this.setState({ top2500StoreTab: !!tab })}
                defaultTab={0}
              >
                <Tab title={translate('ocurr.code.8.by.section')}>
                  {(() => {
                    const list = rupture?.listLMPerSectionTopThousand || []
                    if (list.length === 0 || list.every(item => (item.quantity || 0) === 0)) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <p>Não há dados para o período selecionado.</p>
                        </div>
                      )
                    }
                    return (
                      <>
                        <table className='full-w text-left header-table'>
                          <thead>
                            <tr>
                              <td width='50%'>{translate('ruptures.section')}</td>
                              <td className='text-center' width='25%'>
                                {translate('ruptures.lmQuantity')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('percentage')}
                              </td>
                            </tr>
                          </thead>
                        </table>
                        <CompactTable {...this.compactTableDataForTop2500} />
                      </>
                    )
                  })()}
                </Tab>
                <Tab title={translate('ocurr.code.8.by.store')}>
                  {(() => {
                    // Se não houver dados por loja da API, calcular a partir dos dados disponíveis usando TOP 2500
                    // Nova estrutura: listLMPerStoreTopThousand, estrutura antiga: listLMPerSectionTopThousandByStore
                    let storesList = rupture?.listLMPerStoreTopThousand || rupture?.listLMPerSectionTopThousandByStore || []
                    
                    // Se houver dados da API com a nova estrutura (listLMPerStoreTopThousand com listLMPerTop)
                    if (storesList.length > 0 && storesList[0]?.listLMPerTop !== undefined) {
                      // Converter a nova estrutura do backend para o formato esperado pelo componente
                      storesList = storesList
                        .filter(store => (store.total || store.quantity || 0) > 0)
                        .map(store => {
                          // Formatar nome da loja: "idBranch - dsBranch"
                          const storeName = store.dsBranch 
                            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
                            : store.ds || store.name || store.idBranch || ''
                          
                          // Converter listLMPerTop para storeDetails (seções)
                          const storeDetails = (store.listLMPerTop || [])
                            .filter(section => (section.quantity || 0) > 0)
                            .map(section => ({
                              ds: section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || '',
                              quantity: section.quantity || 0,
                              percent: section.percent || 0,
                            }))
                          
                          return {
                            id: store.idBranch,
                            ds: storeName,
                            name: storeName,
                            quantity: store.total || store.quantity || 0,
                            percent: store.percent || 0,
                            storeDetails: storeDetails,
                          }
                        })
                    } else if (storesList.length === 0 && rupture && this.state.formData?.locationId && rupture.topThousand > 0) {
                      // Se não houver dados da API, calcular a partir dos dados disponíveis usando TOP 2500
                      storesList = this.groupDataByStoreForTop2500(rupture, this.state.formData)
                    } else if (storesList.length > 0) {
                      // Formato antigo (compatibilidade): filtrar valores > 0 e formatar detalhes
                      storesList = storesList
                        .filter(store => (store.total || store.quantity || 0) > 0)
                        .map(store => {
                          // Se os detalhes vierem da API, filtrar apenas valores > 0
                          const filteredDetails = (store.storeDetails || [])
                            .filter(detail => (detail.quantity || 0) > 0)
                            .map(detail => {
                              // Formatar descrição da seção
                              let formattedDs = detail.ds || ''
                              if (detail.cd) {
                                formattedDs = `${detail.cd} - ${detail.ds || ''}`
                              }
                              return {
                                ...detail,
                                ds: formattedDs,
                              }
                            })
                          return {
                            ...store,
                            storeDetails: filteredDetails,
                          }
                        })
                    }
                    
                    // Ordenar lojas numericamente pelo código (id)
                    if (storesList.length > 0) {
                      storesList = [...storesList].sort((a, b) => {
                        const getNumericId = (item) => {
                          if (item.id) {
                            const num = parseInt(item.id)
                            if (!isNaN(num)) return num
                          }
                          if (item.ds) {
                            const match = item.ds.match(/^(\d+)/)
                            if (match) {
                              const num = parseInt(match[1])
                              if (!isNaN(num)) return num
                            }
                          }
                          return 0
                        }
                        return getNumericId(a) - getNumericId(b)
                      })
                    }
                    
                    // Filtrar novamente para garantir que apenas lojas com quantidade > 0 sejam exibidas
                    storesList = storesList.filter(store => (store.total || store.quantity || 0) > 0)
                    
                    if (storesList.length === 0) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <p>Não há dados para o período selecionado.</p>
                        </div>
                      )
                    }
                    
                    
                    return (
                      <>
                        <table className='full-w text-center header-table'>
                          <thead>
                            <tr>
                              <td className='text-left' width='50%'>
                                {translate('scheduleBlock.branchs')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('ruptures.lmQuantity')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('percentage')}
                              </td>
                            </tr>
                          </thead>
                        </table>
                        {storesList.map((store, index) => {
                          const storeQuantity = store.total || store.quantity || 0
                          const storePercent = store.percent || 0
                          const storeName = store.ds || store.name || store.idBranch || ''
                          
                          return (
                            <Accordion
                              isNewComponent
                              key={store.id || store.idBranch || storeName || index}
                              size='sm'
                              title={
                                <AccordionTableTitleStores
                                  branch={storeName}
                                  quantity={storeQuantity}
                                  percentage={`${storePercent}%`}
                                />
                              }
                              className='margin-top no-margin-bottom accordion-box'
                            >
                              <CompactTable
                                {...this.compactTableAccordionDataMock((store.storeDetails || []).filter(detail => (detail.quantity || 0) > 0))}
                              />
                            </Accordion>
                          )
                        })}
                      </>
                    )
                  })()}
                </Tab>
              </NavTab>
              <div className='modal-buttons-footer'>
                <button
                  onClick={this.closeModal}
                  className='custom-modal-close-button'
                >
                  {translate('close_button_label')}
                </button>
                <ReportDownloadBtn
                  onReport={() => this.generateCsvTop2500()}
                  t={translate}
                />
              </div>
            </Modal>
          )}

          {this.state.detailsMode === RUPTURE_TYPE.LMS && (
            <Modal
              className='code-8-modal'
              closeModal={this.closeModal}
              size='md'
            >
              <br />
              <div className='modal-title'>
                {translate('ruptures.sectionTitle')}
              </div>
              <span className='big-number'>{this.totalLMsBySection || 0}</span>
              <br />
              {this.state.dateStartFiltered ||
                moment().format('DD/MM/YYYY')} -{' '}
              {this.state.dateEndFiltered || moment().format('DD/MM/YYYY')}
              <p>{translate('ruptures.sectionText')}</p>
              <br />
              <NavTab
                onChange={(tab) => this.setState({ sectionsStoreTab: !!tab })}
                defaultTab={0}
              >
                <Tab title={translate('ocurr.code.8.by.section')}>
                  {(() => {
                    const list = rupture?.listLMPerSection || []
                    if (list.length === 0 || list.every(item => (item.quantity || 0) === 0)) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <p>Não há dados para o período selecionado.</p>
                        </div>
                      )
                    }
                    return (
                      <>
                        <table className='full-w text-left header-table'>
                          <thead>
                            <tr>
                              <td width='50%'>{translate('ruptures.section')}</td>
                              <td className='text-center' width='25%'>
                                {translate('ruptures.lmQuantity')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('percentage')}
                              </td>
                            </tr>
                          </thead>
                        </table>
                        <CompactTable {...this.compactTableDataForSections} />
                      </>
                    )
                  })()}
                </Tab>
                <Tab title={translate('ocurr.code.8.by.store')}>
                  {(() => {
                    // Se não houver dados por loja da API, calcular a partir dos dados disponíveis usando Seções
                    // Nova estrutura: listLMPerStoreSections, estrutura antiga: listLMPerSectionByStore
                    let storesList = rupture?.listLMPerStoreSections || rupture?.listLMPerSectionByStore || []
                    
                    // Se houver dados da API com a nova estrutura (listLMPerStoreSections com listLMPerTop)
                    if (storesList.length > 0 && storesList[0]?.listLMPerTop !== undefined) {
                      // Converter a nova estrutura do backend para o formato esperado pelo componente
                      storesList = storesList
                        .filter(store => (store.total || store.quantity || 0) > 0)
                        .map(store => {
                          // Formatar nome da loja: "idBranch - dsBranch"
                          const storeName = store.dsBranch 
                            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
                            : store.ds || store.name || store.idBranch || ''
                          
                          // Converter listLMPerTop para storeDetails (seções)
                          const storeDetails = (store.listLMPerTop || [])
                            .filter(section => (section.quantity || 0) > 0)
                            .map(section => ({
                              ds: section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || '',
                              quantity: section.quantity || 0,
                              percent: section.percent || 0,
                            }))
                          
                          return {
                            id: store.idBranch,
                            ds: storeName,
                            name: storeName,
                            quantity: store.total || store.quantity || 0,
                            percent: store.percent || 0,
                            storeDetails: storeDetails,
                          }
                        })
                    } else if (storesList.length === 0 && rupture && this.state.formData?.locationId && rupture.sections > 0) {
                      // Se não houver dados da API, calcular a partir dos dados disponíveis usando Seções
                      storesList = this.groupDataByStoreForSections(rupture, this.state.formData)
                    } else if (storesList.length > 0) {
                      // Se houver dados da API, filtrar valores > 0
                      storesList = storesList
                        .filter(store => (store.quantity || 0) > 0)
                        .map(store => {
                          // Se os detalhes vierem da API, filtrar apenas valores > 0
                          const filteredDetails = (store.storeDetails || []).filter(detail => (detail.quantity || 0) > 0)
                          return {
                            ...store,
                            storeDetails: filteredDetails,
                          }
                        })
                    }
                    
                    // Ordenar lojas numericamente pelo código (id)
                    if (storesList.length > 0) {
                      storesList = [...storesList].sort((a, b) => {
                        const getNumericId = (item) => {
                          if (item.id) {
                            const num = parseInt(item.id)
                            if (!isNaN(num)) return num
                          }
                          if (item.ds) {
                            const match = item.ds.match(/^(\d+)/)
                            if (match) {
                              const num = parseInt(match[1])
                              if (!isNaN(num)) return num
                            }
                          }
                          return 0
                        }
                        return getNumericId(a) - getNumericId(b)
                      })
                    }
                    
                    // Filtrar novamente para garantir que apenas lojas com quantidade > 0 sejam exibidas
                    storesList = storesList.filter(store => (store.total || store.quantity || 0) > 0)
                    
                    if (storesList.length === 0) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <p>Não há dados para o período selecionado.</p>
                        </div>
                      )
                    }
                    
                    
                    return (
                      <>
                        <table className='full-w text-center header-table'>
                          <thead>
                            <tr>
                              <td className='text-left' width='50%'>
                                {translate('scheduleBlock.branchs')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('ruptures.lmQuantity')}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('percentage')}
                              </td>
                            </tr>
                          </thead>
                        </table>
                        {storesList.map((store, index) => {
                          const storeQuantity = store.total || store.quantity || 0
                          const storePercent = store.percent || 0
                          const storeName = store.ds || store.name || store.idBranch || ''
                          
                          return (
                            <Accordion
                              isNewComponent
                              key={store.id || store.idBranch || storeName || index}
                              size='sm'
                              title={
                                <AccordionTableTitleStores
                                  branch={storeName}
                                  quantity={storeQuantity}
                                  percentage={`${storePercent}%`}
                                />
                              }
                              className='margin-top no-margin-bottom accordion-box'
                            >
                              <CompactTable
                                {...this.compactTableAccordionDataMock((store.storeDetails || []).filter(detail => (detail.quantity || 0) > 0))}
                              />
                            </Accordion>
                          )
                        })}
                      </>
                    )
                  })()}
                </Tab>
              </NavTab>
              <div className='modal-buttons-footer'>
                <button
                  onClick={this.closeModal}
                  className='custom-modal-close-button'
                >
                  {translate('close_button_label')}
                </button>
                <ReportDownloadBtn
                  onReport={() => this.generateCsvSections()}
                  t={translate}
                />
              </div>
            </Modal>
          )}

          {this.state.detailsMode === RUPTURE_TYPE.SALES && (
            <Modal
              className='code-8-modal'
              closeModal={this.closeModal}
              size='md'
            >
              <br />
              <div className='modal-title'>
                {translate('ruptures.lossSaleTitle')}
              </div>
              <span className='big-number red'>
                {this.totalLossOfSalesByStore > 0
                  ? `${currency} ${Mask.toMoney(
                      this.totalLossOfSalesByStore.toFixed(sizeCurrency),
                      formatCurrency
                    )}`
                  : `${currency} 0,00`}
              </span>
              <br />
              {this.state.dateStartFiltered ||
                moment().format('DD/MM/YYYY')} -{' '}
              {this.state.dateEndFiltered || moment().format('DD/MM/YYYY')}
              <p>{translate('ruptures.lossSaleText')}</p>
              <br />
              <NavTab
                onChange={(tab) => this.setState({ salesStoreTab: !!tab })}
                defaultTab={0}
              >
                <Tab title={translate('ocurr.code.8.by.section')}>
                  {(() => {
                    const list = rupture?.listRupturePerSection || []
                    if (list.length === 0 || list.every(item => (item.quantity || item.value || 0) === 0)) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <p>Não há dados para o período selecionado.</p>
                        </div>
                      )
                    }
                    return (
                      <>
                        <table className='full-w text-left header-table'>
                          <thead>
                            <tr>
                              <td width='50%'>{translate('ruptures.section')}</td>
                              <td className='text-center' width='25%'>
                                {translate('ruptures.estimatedLoss').replace(
                                  '{0}',
                                  currency
                                )}
                              </td>
                              <td className='text-center' width='25%'>
                                {translate('percentage')}
                              </td>
                            </tr>
                          </thead>
                        </table>
                        <CompactTable {...this.compactTableDataForLossSales} />
                      </>
                    )
                  })()}
                </Tab>
                <Tab title={translate('ocurr.code.8.by.store')}>
                  {(() => {
                    // Se não houver dados por loja da API, calcular a partir dos dados disponíveis usando Seções
                    // Nova estrutura: listRupturePerStore, estrutura antiga: listRupturePerSectionByStore
                    let revenueLossStores = rupture?.listRupturePerStore || rupture?.listRupturePerSectionByStore || []
                    
                    // Se houver dados da API com a nova estrutura (listRupturePerStore com listLMPerTop)
                    if (revenueLossStores.length > 0 && revenueLossStores[0]?.listLMPerTop !== undefined) {
                      // Converter a nova estrutura do backend para o formato esperado pelo componente
                      revenueLossStores = revenueLossStores
                        .filter(store => (store.total || store.quantity || 0) > 0)
                        .map(store => {
                          // Formatar nome da loja: "idBranch - dsBranch"
                          const storeName = store.dsBranch 
                            ? `${store.idBranch || ''} ${store.dsBranch}`.trim()
                            : store.ds || store.name || store.idBranch || ''
                          
                          // Converter listLMPerTop para sectionsDetails (seções)
                          // CORREÇÃO: Arredondar cada valor de seção para 2 casas decimais ANTES de somar
                          const sectionsDetails = (store.listLMPerTop || [])
                            .filter(section => (section.quantity || 0) > 0)
                            .map(section => {
                              // Arredondar o valor da seção para 2 casas decimais
                              const rawValue = section.quantity || 0
                              const roundedValue = parseFloat(rawValue.toFixed(sizeCurrency))
                              return {
                                sections: section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || '',
                                value: roundedValue,
                                percent: section.percent || 0,
                              }
                            })
                          
                          
                          const calculatedTotal = sectionsDetails.reduce((sum, section) => sum + section.value, 0)
                        
                          const finalTotal = parseFloat(calculatedTotal.toFixed(sizeCurrency))
                          
                          return {
                            id: store.idBranch,
                            ds: storeName,
                            name: storeName,
                            branch: storeName,
                            value: finalTotal,
                            quantity: finalTotal,
                            percent: store.percent || 0,
                            sectionsDetails: sectionsDetails,
                          }
                        })
                    } else if (revenueLossStores.length === 0 && rupture && this.state.formData?.locationId && this.totalLossOfSales > 0) {
                      // Criar mapa de códigos de loja para labels (nomes completos) - igual ao primeiro card
                      const branchLabelMap = {}
                      if (Array.isArray(this.state.formData?.locationId)) {
                        this.state.formData.locationId.forEach(branch => {
                          if (branch.value && branch.label) {
                            branchLabelMap[branch.value] = branch.label
                          }
                        })
                      }
                      
                      // Se não houver dados da API, calcular a partir dos dados disponíveis usando Seções
                      const sectionList = rupture?.listRupturePerSection || []
                      const filteredSectionList = sectionList.filter(item => (item.value || item.quantity || 0) > 0)
                      
                      if (filteredSectionList.length > 0) {
                        const calculatedStores = this.groupDataByStoreForSection(rupture, this.state.formData, filteredSectionList)
                        
                        // Converter estrutura calculada para formato sectionsDetails (compatível com AccordionTableTitleLost)
                        revenueLossStores = calculatedStores.map(store => {
                          const sectionsDetails = (store.storeDetails || [])
                            .filter(detail => (detail.value || detail.quantity || 0) > 0)
                            .map(detail => {
                              const detailValue = detail.value || detail.quantity || 0
                              return {
                                sections: detail.ds || detail.sections || '',
                                value: detailValue,
                                percent: detail.percent || 0,
                              }
                            })
                          
                          return {
                            id: store.id,
                            ds: store.ds,
                            name: store.name,
                            branch: store.ds || store.name || '',
                            value: store.value || store.quantity || 0,
                            quantity: store.quantity || store.value || 0,
                            percent: store.percent || 0,
                            sectionsDetails: sectionsDetails,
                          }
                        })
                      }
                    } else if (revenueLossStores.length > 0) {
                      // Se houver dados da API, filtrar valores > 0 e garantir estrutura correta
                      revenueLossStores = revenueLossStores
                        .filter(store => {
                          const storeValue = store.value || store.quantity || 0
                          return storeValue > 0
                        })
                        .map(store => {
                          const storeValue = store.value || store.quantity || 0
                          let sectionsDetails = store.sectionsDetails || []
                          
                          // Se não tiver sectionsDetails, converter de storeDetails
                          if (sectionsDetails.length === 0 && store.storeDetails && store.storeDetails.length > 0) {
                            sectionsDetails = store.storeDetails
                              .filter(detail => {
                                const detailValue = detail.value || detail.quantity || 0
                                return detailValue > 0
                              })
                              .map(detail => {
                                const detailValue = detail.value || detail.quantity || 0
                                return {
                                  sections: detail.ds || detail.sections || '',
                                  value: detailValue,
                                  percent: detail.percent || 0,
                                }
                              })
                          } else if (sectionsDetails.length === 0) {
                            // Se não tiver nenhum detalhe, construir a partir de listRupturePerSection
                            const listRupturePerSection = rupture?.listRupturePerSection || []
                            sectionsDetails = listRupturePerSection
                              .filter(section => {
                                const sectionValue = section.value || section.quantity || 0
                                return sectionValue > 0
                              })
                              .map(section => {
                                const sectionValue = section.value || section.quantity || 0
                                return {
                                  sections: section.cd ? `${section.cd} - ${section.ds || ''}` : section.ds || '',
                                  value: sectionValue,
                                  percent: section.percent || 0,
                                }
                              })
                          }
                          
                          // Obter o nome da loja no formato correto (igual ao primeiro card)
                          let displayName = store.branch
                          if (!displayName) {
                            const storeId = store.id || store.ds?.split(' - ')[0] || store.branch?.split(' - ')[0] || ''
                            const storeBranch = store.ds || store.name || store.branch || ''
                            const branchLabel = branchLabelMap[storeId] || storeBranch
                            displayName = branchLabelMap[storeId] ? branchLabel : (storeBranch || `Loja ${storeId}`)
                          }
                          
                          return {
                            ...store,
                            branch: displayName,
                            value: storeValue,
                            sectionsDetails: sectionsDetails.filter(detail => (detail.value || 0) > 0),
                          }
                        })
                    }
                    
                    // Ordenar lojas numericamente pelo código (id) - mesma lógica do primeiro card
                    if (revenueLossStores.length > 0) {
                      revenueLossStores = [...revenueLossStores].sort((a, b) => {
                        // Tentar extrair o código numérico do id ou do início do ds/branch
                        const getNumericId = (item) => {
                          if (item.id) {
                            const num = parseInt(item.id)
                            if (!isNaN(num)) return num
                          }
                          // Tentar extrair do início do ds ou branch (ex: "0004 - LOJA CONTAGEM" -> 4)
                          const text = item.ds || item.branch || item.name || ''
                          if (text) {
                            const match = text.match(/^(\d+)/)
                            if (match) {
                              const num = parseInt(match[1])
                              if (!isNaN(num)) return num
                            }
                          }
                          return 0
                        }
                        return getNumericId(a) - getNumericId(b)
                      })
                    }
                    
                    // Filtrar novamente para garantir que apenas lojas com valor > 0 sejam exibidas
                    let storesList = revenueLossStores.filter(store => {
                      const storeValue = store.value || store.quantity || 0
                      return storeValue > 0
                    })
                    
                
                    if (storesList.length > 0) {
                      const totalBySection = this.totalLossOfSalesByStore
                      const sumOfStores = storesList.reduce((sum, store) => {
                        return sum + (parseFloat(store.value) || 0)
                      }, 0)
                      const roundedSumOfStores = parseFloat(sumOfStores.toFixed(sizeCurrency))
                      const difference = parseFloat((totalBySection - roundedSumOfStores).toFixed(sizeCurrency))
                      
              
                      if (difference !== 0) {
                        // Encontrar o índice da maior loja
                        let maxIndex = 0
                        let maxValue = 0
                        storesList.forEach((store, index) => {
                          const val = parseFloat(store.value) || 0
                          if (val > maxValue) {
                            maxValue = val
                            maxIndex = index
                          }
                        })
                        
                        
                        storesList = storesList.map((store, index) => {
                          if (index === maxIndex) {
                            const adjustedValue = parseFloat(((parseFloat(store.value) || 0) + difference).toFixed(sizeCurrency))
                            return {
                              ...store,
                              value: adjustedValue,
                              quantity: adjustedValue,
                            }
                          }
                          return store
                        })
                      }
                    }
                    
                    if (storesList.length === 0) {
                      return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                          <p>Não há dados para o período selecionado.</p>
                        </div>
                      )
                    }
                    
                    return (
                      <>
                        <table className='full-w text-left header-table'>
                          <thead>
                            <tr>
                              <td width='50%'>{translate('scheduleBlock.branchs')}</td>
                              <td className='text-center' width='25%'>
                                {translate('order_status.value')}
                              </td>
                              <td className='text-center' width='25%'>
                                %
                              </td>
                            </tr>
                          </thead>
                        </table>
                        {storesList.map((store, index) => (
                          <Accordion
                            isNewComponent
                            key={store.branch || store.id || store.ds || index}
                            size='sm'
                            title={
                              <AccordionTableTitleLost
                                branch={store.branch || store.ds || store.name || ''}
                                value={`${currency} ${Mask.toMoney(
                                  (parseFloat(store.value) || 0).toFixed(sizeCurrency),
                                  formatCurrency
                                )}`}
                                percentage={`${store.percent || 0}%`}
                              />
                            }
                            className='margin-top no-margin-bottom accordion-box'
                          >
                            <CompactTable {...this.compactTableAccordionDataMockSales(store.sectionsDetails || [])} />
                          </Accordion>
                        ))}
                      </>
                    )
                  })()}
                </Tab>
              </NavTab>
              <div className='modal-buttons-footer'>
                <button
                  onClick={this.closeModal}
                  className='custom-modal-close-button'
                >
                  {translate('close_button_label')}
                </button>
                <ReportDownloadBtn
                  onReport={() => this.generateCsvLossSales()}
                  t={translate}
                />
              </div>
            </Modal>
          )}

          {/* Modal/overlay de carregamento durante downloads - removido para downloads fora dos cards */}
          {this.state.showDownloadLoader && (
          <div
            className={`new-style-loader show`}
            style={{ 
              zIndex: 99999, 
              position: 'fixed', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0,
              display: 'block',
              opacity: 1,
              visibility: 'visible'
            }}
          >
            <div className='box'>
              <div className='icon' />
              <p className='title'>{translate('commonReport.loading.title')}</p>
              <p className='text'>
                {ReactHtmlParser(translate('commonReport.loading.text'))}
              </p>
              <button 
                className='cancel' 
                onClick={this.onCancelDownload}
                style={{ 
                  display: 'block', 
                  visibility: 'visible',
                  opacity: 1,
                  margin: '50px auto 0 auto',
                  textAlign: 'center',
                  width: 'auto',
                  position: 'relative',
                  zIndex: 100000
                }}
              >
                {translate('commonReport.loading.cancel')}
              </button>
            </div>
          </div>
          )}

          {/* Modal/overlay de carregamento durante busca inicial de dados */}
          {this.state.showFilterLoader && (
          <div
            className={`new-style-loader show`}
            style={{ 
              zIndex: 99999, 
              position: 'fixed', 
              top: 0, 
              left: 0, 
              right: 0, 
              bottom: 0,
              display: 'block',
              opacity: 1,
              visibility: 'visible'
            }}
          >
            <div className='box'>
              <div className='icon' />
              <p className='title'>{translate('commonReport.loading.title')}</p>
              <p className='text'>
                {ReactHtmlParser(translate('commonReport.loading.text'))}
              </p>
              <button 
                className='cancel' 
                onClick={this.onCancelFilter}
                style={{ 
                  display: 'block', 
                  visibility: 'visible',
                  opacity: 1,
                  margin: '50px auto 0 auto',
                  textAlign: 'center',
                  width: 'auto',
                  position: 'relative',
                  zIndex: 100000
                }}
              >
                {translate('commonReport.loading.cancel')}
              </button>
            </div>
          </div>
          )}
        </div>
      </section>
    )
  }
}

RuptureContainer.propTypes = {
  translate: PropTypes.func,
  auth: PropTypes.object.isRequired,
  fetchFluxReport: PropTypes.func.isRequired,
  fetchReports: PropTypes.func.isRequired,
  fetchRuptures: PropTypes.func.isRequired,
  rupture: PropTypes.object,
}

/*
 * Maps redux state to component props
 */
const mapStateToProps = (state) => {
  return {
    auth: state.authReducer || state.auth,
    rupture: state.ruptureReducer?.record,
    error: state.ruptureReducer?.error,
    filters: state.ruptureReducer?.filters,
  }
}

/*
 * Maps actions and dispatch them to component props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...reportActions, ...ruptureActions }, dispatch)

/*
 * Connects component to I18next
 */
const RuptureTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(RuptureContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(mapStateToProps, mapDispatchToProps)(RuptureTranslated)

/*
 * Exports as component
 */
export { RuptureContainer }
